import React, { useEffect, useState, useRef } from 'react'
import { Row, Col, Select, Form, Button, Spin, Modal, Tooltip, Checkbox } from 'antd'
import { useLocation, useHistory, useParams, Link } from 'react-router-dom'
import { convertBase64, dateFormatter, financial } from '../../services/helper'
import { getTRanferByIban, setTableData } from 'store/actions/transfers'
import FullScreenLoading from "components/FullScreenLoading";

import {
  getTransfers,
  getTransfersDetail,
  getBusinessDate,
  getTransfersStatusCount,
  getTransfersFiltered, getAllFilesOrderPdfByName, getPaymentOrderPdfByIbanRefMultiple, getAllFilesOrderExcel,
} from './../../services/transfers'

import {
  getAllFilesOrderAdocByIbanRef,
  getPaymentOrderPdfByIbanRef,
  MassTransferFile,
} from './../../services/transfers'
import { deleteTransferNew, getAccounts } from '../../services/account'

import { connect } from 'react-redux'

import TableComponent from 'components/Table'
import SelectField from 'components/SelectField'
import SortableColumn from 'components/Table/ColumnSort'
import SearchableColumn from 'components/Table/ColumnSearch'
import CustomTooltip from 'components/Tooltip'
import TransfersFilter from './TransfersFilter/index'
import { getCurrentCompany, getRoleData } from '../../services/user'
import { CircleCheckbox } from 'components/CircledCheckbox'

import { typeRender, modalRender, redirectPage } from './TypeStatusRender'
import {
  roleRender,
  statusRender,
  ALLOptions,
  dateFilter,
  currencyFilter,
  typeFilter,
  selectStatusOptionsStatic,
} from './StatusRender'

import {
  NavigationLeftIco,
  TabsInfoIco,
  CycleIco, PlusIco, ModalCloseIco,
  EroorIco,
} from '../../../modules/CustomIcons'
import TransfersFooter from './TransfersFooter'
import moment from 'moment'
import '../Salary/index.scss'
import './index.scss'
import { LOGIN_PAGE, Spinner } from 'constants/constants'
import { useActions } from '../../hooks/useActions'
import NextModal from "components/NextModal";
import NextModalTransfers from "components/NextModalTransfers";
import { getTrannsferByIban } from "../../services/Transfers/transfers";
import { trnTypes } from "../../../root/Routes/Routes";
import { secureLocalStorageGet } from "../../helpers";
import { API_URL, httpVeryfied } from "../../services/config";
import { sendTransactionApprove, sendTransactionSendToBank } from "../../services/Auth/TransactionApprove";
import asanLogo from "assets/images/icons/asan-logo.png";
import questionMark from "assets/images/icons/question.png";
import { QRCodeSVG } from 'qrcode.react';
import '../Login/components/Sidebar/SIMAEntrance/sima.scss';
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import OtpInput from "react-otp-input";
import Timer from "components/Timer";
import SuccessOrErrorModal from "components/SuccessOrErrorModal";
import { getTransactionStatus } from "../../services/Auth/TransactionStatus";
import { useTranslation } from 'react-i18next'
import { getMessageList } from "../../services/info";
import { useConveyer } from "@egjs/react-conveyer";
import * as XLSX from "xlsx/xlsx.mjs";
import i18next from 'i18next'
import { getPaymentcheck } from "../../services/Transfers/GppTransfer";
import errorStatus from "assets/images/icons/errorStatus.svg";
import { log } from 'console'
import { getLoggedUserInfo } from '../../services/Auth/GetUserInfo'

const SIMA_SIGN_DURATION = 300

const SIMA_QR_PLACEHOLDER = 'https://simaimza.az/placeholder/activate?ref=login&session=00000000-0000-0000-0000-000000000000'

const formatSimaTime = (time: number) => {
  const minutes = Math.floor(time / 60)
  const seconds = time % 60
  return `0${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`
}

const Transfers: React.FC<any> = ({ formValue, sourceComingPage, messageList }) => {
  const { t } = useTranslation();
  const ref = useRef<HTMLDivElement>(null);
  useConveyer(ref, {
    horizontal: true,
  });
  const text = (
    <div className="ant-tooltip-inner__data">{t("settings.asanInfo")}<br />
      <span><a href='https://www.asanimza.az' target="_blank">www.asanimza.az</a></span>
    </div>
  )
  const { getTRanferByIban } = useActions()
  const [form] = Form.useForm()
  const history = useHistory()
  const pageOptions = [10, 50, 100]
  const [fileData, setFileData] = useState<MassTransferFile>()
  const [pageSize, setPageSize] = useState(10)
  const [searchable, setSearchable] = useState(false)
  const [tableData, setFilteredTableData] = useState([])
  const [tableList, setTableFilterList] = useState(tableData)
  const [tableListForFilter, setTableFilterListForFilter] = useState(tableData)
  const [tableListForSortOriginal, setTableListForSortOriginal] = useState(tableData)
  const [tableListCash, setTableListCash] = useState([])
  const [innerTableData, setInnerData] = useState({})
  const [detailDataState, setDetailData] = useState({})
  const [modalVisible, setModalVisibility] = useState(false)
  const [packages, setPackages] = useState([])
  const [selectAccountOptions, setAccountOptions] = useState([])
  const [modalType, setModalType] = useState('')
  const [modalDataSingle, setModalDataSingle] = useState({})
  const [checked, setChecked] = useState(false)
  const [row, setRowClick] = useState(false)
  const [commonModalData, setComonModalData] = useState([])
  const [selectedRowKeys, setCheckedList] = useState([])
  const [btnCount, setBtnCount] = useState([])
  // const [activeStatbtn, setActiveBtn] = useState([])
  const [statusForSign, setForSign] = useState(0)
  const [activeIndex, setActiveClass] = useState(0)
  const [activeIndexDate, setDateIndex] = useState(1)
  const [businessDate, setBusinessDate] = useState('')
  const [isRefresh, setRefresh] = useState(false)
  const [showSpinner, setShowSpinner] = useState<boolean>(false)
  const [tableLoading, setTableLoading] = useState(Spinner)
  const [current, setCurrent] = useState(1)
  const [argument, setArguments] = useState()
  const [editDisable, setEditDisable] = useState(true)
  const [repeatDisable, setRepeatDisable] = useState(true)
  const [deleteDisable, setDeleteDisable] = useState(true)
  const [adocDisable, setAdocDisable] = useState(true)
  const [simaAdocDisable, setSimaAdocDisable] = useState(true)
  const [simaAdocModalVisible, setSimaAdocModalVisible] = useState(false)
  const [startDate, setStartDate] = useState(moment())
  const [endDate, setEndDate] = useState(moment())
  const [loadingPdf, setLoadingPdf] = useState(false)
  const [loadingAll, setLoadingAll] = useState(false)
  const [btnData, setBtnData] = useState({})
  const [type, setType] = useState('')
  const [type1, setType1] = useState('')
  const [documentDetail, setDocumentDetail] = useState([])
  const [btnDataModal, setBtnDataModal] = useState({})
  const [visibleDeleteModal, setVisibleDeleteModal] = useState(false)
  const [btnStatus, setBtnStatus] = useState({})
  const [selectedType, setSelectedType] = useState("")
  const [multiple, setMultiple] = useState(false)
  const [selectedIbanRef, setSelectedIbanRef] = useState("")
  const [argCash, setArgCash] = useState({})
  const [dateList, setDateList] = useState([]);
  const [typeList, setTypeList] = useState([[{ label: t("common.all"), value: 'all' }]]);
  const [currencyList, setCurrencyList] = useState([]);
  const [buttonClicked, setButtonClicked] = useState(0);
  const [noteList, setNoteList] = useState([]);
  const [historyList, setHistoryList] = useState([]);
  const [loadingExcel, setLoadingExcel] = useState(false)
  const [buttonClickedTriggerChild, setButtonClickedTriggerChild] = useState(0);
  const [loadingApprove, setLoadingApprove] = useState<boolean>(false)
  const [loadingSend, setLoadingSend] = useState<boolean>(false)
  const [modalText, setModalText] = useState<string>(`?m?liyyat ugurla saxlanilmis, imzalanmisdir v? banka g�nd?rilm?sini g�zl?m?kd?dir.`)
  const [popupType, setPopupType] = useState("success")
  let channel = secureLocalStorageGet('channel')
  const [otpNumberCount, setOtpNumberCount] = useState<number>(6)
  const [otpNumberCountTrList, setOtpNumberCountTrList] = useState<number>(5)
  
  const [phoneNumber, setPhoneNumber] = useState<string>()
  const [otpCodeModalVisible, setOtpCodeModalVisible] = useState(false)
  const [otpCodeModalVisibleTrList, setOtpCodeModalVisibleTrList] = useState(false)
  const [verifyCode, setVerifyCode] = useState<number>()
  const [asanModalVisible, setAsanModalVisible] = useState(false)
  const [simaModalVisible, setSimaModalVisible] = useState(false)
  const [simaQrCode, setSimaQrCode] = useState<string>('')
  const [simaTimeLeft, setSimaTimeLeft] = useState(SIMA_SIGN_DURATION)
  const [simaExpired, setSimaExpired] = useState(false)
  const [simaSignError, setSimaSignError] = useState(false)
  const [simaSignErrorMsg, setSimaSignErrorMsg] = useState('')
  const [simaRefreshKey, setSimaRefreshKey] = useState(0)
  const simaPollingActive = useRef(false)
  const [showSuccessOrError, setShowSuccessOrError] = useState(false)
  const [showTimeError, setShowTimeError] = useState(false)
  const [otpCode, setOtpCode] = useState<number[]>([])
  const [otpCodeHasError, setOtpCodeHasError] = useState<boolean>(false)
  const [otpCodeTrList, setOtpCodeTrList] = useState('')
  const [otpCodeHasErrorTrList, setOtpCodeHasErrorTrList] = useState<boolean>(false)
  const [loading,setLoading] = useState(false)
  const [errorText,setErrorText] = useState('')
  const [reset, setReset] = useState<boolean>(false)
  const [smsClicked, setClicked] = useState(true)
  const [selectLanguage, setSelectLanguage] = useState('az')
  const [excelData, setExcelData] = useState<any>([])
  const [label, setLabel] = useState(null)
  const [value, setValue] = useState('');
  const [selected, setSelected] = useState(false)
  const [openStatus, setOpenStatus] = useState(false);
  let requestTypeLocal = secureLocalStorageGet('rol')
  const [noHover, setHover] = useState(false)
  const [transferData, setTransferData] = useState([])
  const [chainModalConnect, setChainModalConnect] = useState(false)
  const [chainModal, setChainModal] = useState(false)
  const [date, setDate] = useState('')

  let requestType = ''
  if (requestTypeLocal == '2') {
    requestType = 'SIGN'
  } else if (requestTypeLocal == '3') {
    requestType = 'APPROVE'
  } else {
    requestType = 'MAKER'
  }

  const language = localStorage.getItem("i18nextLng")

  const staticTypeList = [
    { label: t("common.all"), value: 'all' },
    { label: 'IM', value: 'IM' },
    { label: 'IT', value: 'IT' },
    { label: 'FX', value: 'FX' },
    { label: 'AZ', value: 'AZ' },
    { label: 'XO', value: 'XO' },
    { label: 'XT', value: 'XT' },
    { label: 'XV', value: 'XV' },
    { label: 'FP', value: 'FP' },
    { label: 'RP', value: 'RP' },
    { label: 'SP', value: 'SP' }
  ]

  const staticCurrencyList = [
    { label: t("common.all"), value: 'all' },
    { label: 'AZN', value: 'AZN' },
    { label: 'USD', value: 'USD' },
    { label: 'RUB', value: 'RUB' },
    { label: 'EUR', value: 'EUR' },
    { label: 'GBP', value: 'GBP' }
  ]

  const buttonStatusSingle = {
    "SIGNER": {
      "singlePdf": true,
      "allPdf": true,
      "repeat": true,
      "delete": true,
      "edit": true,
      "sign": true,
      "sendToBank": false,
      "excell": false,
      "adoc": false,
      "swift": false,
    },
    "APPROVER": {
      "singlePdf": true,
      "allPdf": true,
      "repeat": true,
      "delete": true,
      "edit": true,
      "sign": true,
      "sendToBank": false,
      "excell": false,
      "adoc": false,
      "swift": false,
    },
    "CLOSED": {
      "singlePdf": true,
      "allPdf": true,
      "repeat": true,
      "delete": false,
      "edit": false,
      "sign": false,
      "sendToBank": false,
      "excell": false,
      "adoc": false,
      "swift": false,
    },
    "EXPIRED": {
      "singlePdf": true,
      "allPdf": true,
      "repeat": true,
      "delete": false,
      "edit": false,
      "sign": false,
      "sendToBank": false,
      "excell": false,
      "adoc": false,
      "swift": false,
    },
    "DELETED": {
      "singlePdf": true,
      "allPdf": true,
      "repeat": true,
      "delete": false,
      "edit": false,
      "sign": false,
      "sendToBank": false,
      "excell": false,
      "adoc": false,
      "swift": false,
    },
    "BANK_ERROR": {
      "singlePdf": true,
      "allPdf": true,
      "repeat": true,
      "delete": false,
      "edit": false,
      "sign": false,
      "sendToBank": true,
      "excell": false,
      "adoc": false,
      "swift": false,
    },
    "BANK_REJECTED": {
      "singlePdf": true,
      "allPdf": true,
      "repeat": true,
      "delete": false,
      "edit": false,
      "sign": false,
      "sendToBank": false,
      "excell": false,
      "adoc": false,
      "swift": false,
    },
    "BANK_SUCCESS": {
      "singlePdf": true,
      "allPdf": true,
      "repeat": true,
      "delete": false,
      "edit": false,
      "sign": false,
      "sendToBank": false,
      "excell": false,
      "adoc": false,
      "swift": false,
    },
    "SEND_TO_BANK": {
      "singlePdf": true,
      "allPdf": true,
      "repeat": true,
      "delete": false,
      "edit": false,
      "sign": false,
      "sendToBank": true,
      "excell": false,
      "adoc": false,
      "swift": false,
    },
    "PENDING_SIGNER": {
      "singlePdf": true,
      "allPdf": true,
      "repeat": true,
      "delete": true,
      "edit": true,
      "sign": false,
      "sendToBank": false,
      "excell": false,
      "adoc": false,
      "swift": false,
    },
    "PENDING_APPROVER": {
      "singlePdf": true,
      "allPdf": true,
      "repeat": true,
      "delete": true,
      "edit": true,
      "sign": false,
      "sendToBank": false,
      "excell": false,
      "adoc": false,
      "swift": false,
    },
    "PENDING_ALL": {
      "singlePdf": true,
      "allPdf": true,
      "repeat": true,
      "delete": true,
      "edit": true,
      "sign": false,
      "sendToBank": false,
      "excell": false,
      "adoc": false,
      "swift": false,
    },
    "ALL": {
      "singlePdf": true,
      "allPdf": true,
      "repeat": false,
      "delete": false,
      "edit": false,
      "sign": false,
      "sendToBank": false,
      "excell": false,
      "adoc": false,
      "swift": false,
    }
  }

  const buttonStatusGroup = {
    "PENDING": {
      "adocButton": false,
      "approveButton": false,
      "closeButton": false,
      "deleteButton": true,
      "editButton": false,
      "excelButton": false,
      "multiplePdfButton": true,
      "repeatButton": false,
      "saveAsTemplateButton": false,
      "sendBankButton": false,
      "signButton": false,
      "singlePdfButton": true,
      "swiftButton": false,
    },
    "ALL": {
      "adocButton": false,
      "approveButton": false,
      "closeButton": false,
      "deleteButton": false,
      "editButton": false,
      "excelButton": false,
      "multiplePdfButton": true,
      "repeatButton": false,
      "saveAsTemplateButton": false,
      "sendBankButton": false,
      "signButton": false,
      "singlePdfButton": true,
      "swiftButton": false,
    }
  }

  const handleCheckboxClickData = () => {
    setChecked(!checked)
    setCheckedList([])
    setBtnStatus({})
    setSelectedType(roleData === 2 ? "PENDING_SIGNER" : roleData === 1 ? "VIEW" : "PENDING_APPROVER")
  }

  let location = useLocation()

  const modalDataCommon = {
    modalTitle: t("transfers.groupTransferTitle"),
    groups: [],
    buttons: [
      { save: true },
      { sign: true },
      { approve: true },
      { send: true },
    ],
  }

  function downloadPDF(fileName: string, fileBase64: string) {
    const linkSource = `data:$application/download;base64,${fileBase64}`
    const downloadLink = document.createElement('a')
    downloadLink.href = linkSource
    downloadLink.download = fileName
    downloadLink.click()
  }
  // function downloadHTML(fileName: string, fileContent: string) {
  //   const decodedContent = decodeURIComponent(escape(atob(fileContent)));; // Decode base64
  //   const linkSource = `data:text/html;charset=utf-8,${encodeURIComponent(decodedContent)}`
  //   const downloadLink = document.createElement('a')
  //   downloadLink.href = linkSource
  //   downloadLink.download = fileName
  //   downloadLink.click()
  // }
  function downloadHTML(files: any) {
    files?.map((file: any) => {
      const fileName = `${t("transfers.receiptnum")}${file?.receiptNumber}`
      const fileBase64 = file?.receiptPrintContent
      const decodedContent = decodeURIComponent(escape(atob(fileBase64))); // Decode base64
      const linkSource = `data:text/html;charset=utf-8,${encodeURIComponent(decodedContent)}`;
      const downloadLink = document.createElement('a');
      downloadLink.href = linkSource;
      downloadLink.download = fileName.endsWith('.html') ? fileName : `${fileName}.html`; // Ensure .html extension
      downloadLink.click();
    })

  }
  const handleDownloadCheck = async () => {
    const data = await getPaymentcheck(selectedRowKeys[0], selectLanguage)
    if (data?.code == '400' || data?.message !== 'SUCCESS') {
      setShowTimeError(true)
    } else {
      return downloadHTML(
        // `${t("transfers.receiptnum")}${data?.receipResultList[0].receiptNumber}`,
        data.receipResultList
        // [0].receiptPrintContent
      )
    }
  }
  const handleGetPdfMultiple = async () => {
    setLoadingPdf(true)
    // if (selectedRowKeys.length == 1) {
    //   let ibankref = selectedRowKeys[0]
    let singlePdf: Array<any> = []
    selectedRowKeys.map((item: any) => {
      return singlePdf.push({
        ibankRef: item

      })
    })
    let postData = { fileDetailsList: singlePdf }
    const data = await getPaymentOrderPdfByIbanRefMultiple(postData, selectLanguage)
    let pdfresult = data.data !== undefined ? data.data.fileDetailsList : []
    pdfresult?.map((item: any) => {
      return downloadPDF(item.fileName, item.fileBase64)
    })
    setLoadingPdf(false)
  }
  // @ts-ignore

  const handleGetPdfSingle = async (selectLang: any) => {
    setLoadingPdf(true)
    // if (selectedRowKeys.length == 1) {
    //   let ibankref = selectedRowKeys[0]
    let singlePdf: Array<any> = []
    if (selectedIbanRef !== "") {
      singlePdf.push({
        ibankRef: selectedIbanRef
      })
    } else {
      selectedRowKeys.map((item: any) => {
        return singlePdf.push({
          ibankRef: item
        })
      })
    }
    let postData = { fileDetailsList: singlePdf }
    let data;
    if (selectLang === "AZ" || selectLang === "EN" || selectLang === "RU") {
      data = await getPaymentOrderPdfByIbanRef(postData, selectLang)

    } else {
      data = await getPaymentOrderPdfByIbanRef(postData, selectLanguage)
    }

    let pdfresult = data.data !== undefined ? data.data.fileDetailsList : []
    pdfresult?.map((item: any) => {
      return downloadPDF(item.fileName, item.fileBase64)
    })
    setLoadingPdf(false)
  }

  const handleGetAdoc = async () => {
    // setRowClick(false)
    if (selectedRowKeys.length == 1) {
      let ibankref = selectedRowKeys[0]
      const data = await getAllFilesOrderAdocByIbanRef(ibankref)
      setFileData(data)
      data?.data.fileDetailsList.map(function (item, i) {
        downloadPDF(ibankref + '_' + i + '.adoc', item.fileBase64)
      })
    } else if (selectedIbanRef !== "") {
      const data = await getAllFilesOrderAdocByIbanRef(selectedIbanRef)
      setFileData(data)
      data?.data.fileDetailsList.map(function (item, i) {
        downloadPDF(selectedIbanRef + '_' + i + '.adoc', item.fileBase64)
      })
    }
  }

  // Downloads a base64 payload as a real PDF (application/pdf MIME + .pdf name) —
  // used by the SIMA-adoc button, which must produce a PDF instead of the .adoc
  // file the regular ADOC button downloads.
  function downloadAsPdf(fileName: string, fileBase64: string) {
    const linkSource = `data:application/pdf;base64,${fileBase64}`
    const downloadLink = document.createElement('a')
    downloadLink.href = linkSource
    downloadLink.download = fileName.toLowerCase().endsWith('.pdf') ? fileName : `${fileName}.pdf`
    downloadLink.click()
  }

  // SIMA-adoc button: same source service as ADOC, but each file is saved as a PDF.
  const handleGetSimaAdoc = async () => {
    const ibankref = selectedRowKeys.length == 1
      ? selectedRowKeys[0]
      : (selectedIbanRef !== "" ? selectedIbanRef : "")
    if (!ibankref) return
    const data = await getAllFilesOrderAdocByIbanRef(ibankref)
    setFileData(data)
    const transferDetail = await getTransfersDetail(ibankref, language)
    const pmtid = (transferDetail as any)?.PMTID || ibankref
    data?.data.fileDetailsList.map(function (item, i) {
      downloadAsPdf(`SIMA_Imza_Document_${pmtid}`, item.fileBase64)
    })
  }

  const handleGetPdfAdditional = async (ibanRef: any, filename: any) => {
    const data = await getAllFilesOrderPdfByName(ibanRef, filename)
    // setFileData(data)
    data?.data.fileDetailsList.map(function (item, i) {
      const downloadLink = document.createElement('a')
      downloadLink.href = item.fileBase64
      downloadLink.download = filename
      downloadLink.click()
    })
  }

  const handleGetAllExcel = async () => {
    setLoadingAll(true)
    const Card_array: React.SetStateAction<any[]> = []
    // let allSource = ("Bütün")
    let date = t("common.date")
    let user = 'istifadəçi'
    let type = t('common.type')
    let getter = t("common.beneficiary")
    let assignment = t("transfers.details")
    let info = t("transfers.infoForBeneficiary")
    let currency = t("home.currency")
    let amount = t("common.amount")
    let docNo = t("salary.documentNo")
    let status = 'Status'
    tableListForSortOriginal.map((row) => {
      Card_array.push({
        [date]: row.date,
        [user]: row.user,
        [type]: row.type,
        [docNo]: row.pmtCustId,
        [getter]: row.getter,
        [assignment]: row.assignment,
        [info]: row.info,
        [currency]: row.currency,
        [amount]: row.amount,
        [status]: statusRender(row.status)
      })
    })

    let wb = XLSX.utils.book_new(),
      ws = XLSX.utils.json_to_sheet(Card_array);

    XLSX.utils.book_append_sheet(wb, ws, 'ExcelFile');

    XLSX.writeFile(wb, 'Exceltransfer.xlsx')

    setLoadingAll(false)
  }
  const handleGetExcelAdditional = async () => {
    setLoadingExcel(true)
    for (let row in selectedRowKeys) {
      // let detailData = await getTransfersDetail(selectedRowKeys[row])
      // const result = detailData?.PDF_LIST?.filter((cert) => cert.mimeType === "application/vnd.ms-excel")
      // if (result !== undefined && result.length > 0) {
      const data = await getAllFilesOrderExcel(selectedRowKeys[row], selectLanguage)
      data?.data.fileDetailsList.map(function (item, i) {
        const linkSource = `data:${item.mimeType};base64,${item.fileBase64}`
        const downloadLink = document.createElement('a')
        downloadLink.href = linkSource
        downloadLink.download = item.fileName
        downloadLink.click()
      })
      // }
    }
    setLoadingExcel(false)
  }

  const handleOther = async () => {

  }



  const handleSign = async () => {
    setRowClick(false)
    // setSelectedIbanRef("")
    if (selectedRowKeys.length == 1) {
      // setBtnDataModal({})
      let ibankref = selectedRowKeys[0]
      handleTransactionReq()
      // setSelectedIbanRef(ibankref)
      // let detailData = await getTransfersDetail(ibankref)
      // setNoteList([])
      // const cashHistory: Array<any> = []
      // if(detailData !== undefined && detailData !== null) {
      //   detailData['HISTORY_DETAILS'].map((item: any) => {
      //     userName: item.userName,
      //         cashHistory.push({
      //       transactionDate: item.transactionDate + ' ' + item.transactionTime,
      //      trnRequestType: item.trnRequestType,
      //       trnStatusAfter: item.trnStatusAfter
      //     });
      //   });
      // }
      // setHistoryList(cashHistory)
      // if(detailData['bankNote'] !== null) {
      //   const line = detailData['HISTORY_DETAILS'];
      //   if(line !== undefined && line !== null && detailData['HISTORY_DETAILS'].length > 0) {
      //     const listCount = detailData['HISTORY_DETAILS'].length - 1;
      //
      //     const a = [{date: detailData['HISTORY_DETAILS'][listCount]['transactionDate'] + " " + detailData['HISTORY_DETAILS'][listCount]['transactionTime'] , userName: detailData['HISTORY_DETAILS'][listCount]['userName'], notification: detailData['bankNote']}]
      //     setNoteList(a);
      //   }
      //
      // }
      // const index = tableList.findIndex((item) => item.key === ibankref)
      // setModalType(tableList[index].type)
      // setBtnDataModal(tableList[index].actionButtons)
      // let modalDataS = await modalRender(tableList[index].type, detailData)
      // setModalDataSingle(modalDataS)
      // setDetailData(detailData)
      // setModalVisibility(true)
      // setMultiple(false)
    }
    else {
      if (selectedRowKeys.length > 1) {
        setModalType("")
        setBtnDataModal({})
        const index = tableList.findIndex((item) => item.key === selectedRowKeys[0])
        setBtnDataModal(tableList[index].actionButtons)
      }
      var result: Array<any> = []
      tableData.reduce(function (res, value) {
        if (!res[value.type]) {
          res[value.type] = { type: value.type, amount: 0, commamount: value.type !== "FX" ? 0 : '', count: 0 }
          res[value.type].count++
          result.push(res[value.type])
        }

        const amount = value?.amount?.toString().replaceAll(" ", "")
        const commamount = value?.commamount?.toString().replaceAll(" ", "")
        res[value.type].amount += +amount
        if (value.type !== "FX")
          res[value.type].commamount += +commamount
        return res
      }, {})
      let resultCount = Object.values(
        tableData.reduce((c, { type }) => {
          c[type] = c[type] || { type, count: 0 }
          c[type].count++
          return c
        }, {})
      )
      let resultMerged = result.map((item, i) =>
        Object.assign({}, item, resultCount[i])
      )
      const groupsArr: Array<any> = []
      resultMerged.map((item: any) => {
        return groupsArr.push({
          title: typeRender(item.type),
          tableHasBorderBottom: true,
          commonList: true,
          data: [
            {
              label: t("transfers.groupTransferCount"),
              value: item.count,
            },
            {
              label: t("transfers.groupTransferAmount"),
              value: item.amount?.toFixed(2),
            },
            {
              label: t("transfers.groupTransferComm"),
              value: item.commamount !== undefined && item.commamount !== '' ? item.commamount.toFixed(2) : '0.00',
            },
          ],
        })
      })
      //@ts-ignore
      setComonModalData(() => ({
        ...modalDataCommon,
        groups: groupsArr
      }))
      setMultiple(true)
      setDetailData({})
      // setDetailData(resultMerged)
      setModalVisibility(true)

      // setModalVisibilityCommon(true)

    }
  }

  const handleModalClose = () => {
    setModalVisibility(false)
    setSelectedIbanRef("")
    setDetailData({})
    setNoteList([])
    // setCheckedList([])
  }
  const onDropdownVisibleChange = (open) => {

    setOpenStatus(open)
    if (open) {
      setSelected(false)
      setTimeout(() => {
        document.querySelector('.ant-select-item.ant-select-item-option')?.classList.remove('ant-select-item-option-active');
      });
    }
  }
  useEffect(() => {
    const layoutScroll = document.getElementById("layout_scroll");
    const dropdownClass = document.getElementsByClassName('ant-select-dropdown ant-select-dropdown-placement-bottomLeft')

    if (typeof layoutScroll !== 'undefined') {
      layoutScroll?.addEventListener('scroll', () => {

        if (dropdownClass[0] !== undefined && !dropdownClass[0].classList.contains('ant-select-dropdown-hidden'))
          dropdownClass[0].classList?.add("ant-select-dropdown-hidden")
      });

      return () => {
        layoutScroll?.removeEventListener('scroll', () => {
          if (dropdownClass[0] !== undefined && !dropdownClass[0].classList.contains('ant-select-dropdown-hidden'))
            dropdownClass[0].classList?.remove("ant-select-dropdown-hidden")
        });
      };
    }
  });
  const columnsData = [
    {
      title: (
        <div className="searchable-column flex select-column transfersAllSource-column">
          <Form form={form} className='allSource-column-form'>
            <Form.Item
              className="column-select"
            >
              <Select
                placeholder={t("transfers.source")}
                label
                options={transferData}
                dropdownClassName={`${noHover ? "selectcolumn-transfer allSource-column" : "hoverable selectcolumn-transfer"}`}
                name={"allSource"}
                onChange={(value: string) => handleFilterColumn(value, 'allSource')}
              />
            </Form.Item>
          </Form>
        </div>

      ),
      dataIndex: 'allSource',
      key: 'allSource',
      width: 50,
      ellipsis: true,
      editable: false,
      render: (text: string) => {

        return (
          <CustomTooltip
            className="table-tooltip"
            title={text?.includes('WEB')
              ? t("transfers.withSourceInternetOffice")
              : text?.includes('BT')
                ? t("transfers.batchtransfers")
                : text?.includes('API') ? "API"
                  : 'Mobil Ofis Biznes'}
            placement="top"
          >
            <p style={{ textAlign: 'center', position: 'relative', left: 2 }}>{text?.includes('WEB')
              ? 'IO'
              : text?.includes('BT')
                ? 'BT'
                : text?.includes('API')
                  ? "API"
                  : "MO"}</p>
          </CustomTooltip>
        )
      },
    },

    {
      title: (
        <div className="flex">
          <SortableColumn

            data={tableList}
            setData={setTableFilterList}
            dataOriginal={tableListForSortOriginal}
            type={"date"}
            parameter={"date"}
            hasTime={true}
          />
          <CustomTooltip
            className="table-tooltip"
            title="Statusun əldə olunması tarixi"
            placement="top"
          >
            {' '}
            <Form form={form} name={'date_filter'}>
              <Select
                placeholder={t("common.date")}
                onChange={(value: string) => handleFilterColumn(value, 'date')}
                style={{ width: 100 }}
                // value={date}
                onDropdownVisibleChange={onDropdownVisibleChange}
                onMouseLeave={() => setHover(true)}
                onMouseEnter={() => setHover(false)}
                dropdownClassName={`${noHover ? "selectcolumn-transfer typeSelect-column" : "hoverable selectcolumn-transfer"}`}

              >
                {
                  dateList?.map((row) => {

                    return <Option value={row.value}>
                      {row.label}
                    </Option>

                  })
                }
              </Select>
              {/* <SelectField
                // open={true}
                // width={95}
                placeholder={t("common.date")}
                width={95}
                // options={dateFilter}
                options={dateList}
                className="status-select"
                name={'date_filter'}
                // onChange={(value: string) => filterHandler(value, 'date')}
                onChange={(value: string) => handleFilterColumn(value, 'date')}
              /> */}
            </Form>
          </CustomTooltip>
        </div>
      ),
      dataIndex: 'date',
      key: 'date',
      className: 'date',
      // sorter: (a, b) => moment(a.date, "DD.MM.YYYY").unix() - moment(b.date, "DD.MM.YYYY").unix(),
      render: (data) => (
        <>
          <p>{data}</p>
        </>
      ),
      ellipsis: true,
      width: 89,
      editable: false,
    },
    {
      title: (
        <div
          className="searchable-column"
        // style={{ width:150}}

        >
          <div className={searchable ? 'bordered flex transferSorter' : 'flex transferSorter'}>
            <SortableColumn
              data={tableList}
              setData={setTableFilterList}
              dataOriginal={tableListForSortOriginal}
              type={"string"}
              parameter={"user"}
            />
            <Form
              form={form}
              className={"transfer-form"}
            >
              <SearchableColumn
                style={{ marginLeft: 30 }}
                large
                title={t("businessCards.user")}
                form={form}
                name={"user"}
                filter={"searchfilter"}
                onChange={(event: any) => handleFilterColumn(event, 'user')}
                buttonClicked={buttonClicked}
              />
            </Form>
          </div>
        </div>
      ),
      dataIndex: 'user',
      key: 'user',
      width: 120,
      ellipsis: true,
      editable: false,
      // sorter: (a: any, b: any) => a.getter.localeCompare(b.getter),
      render: (text, record) => {
        return text?.length > 0 ? (
          <CustomTooltip
            // className="table-tooltip" 
            title={record.lastUserName}>
            <p>{text}</p>
          </CustomTooltip>
        ) : (
          <p>{text}</p>
        )
      },
    },
    {
      title: (
        <div
          className="searchable-column flex select-column transfersType-column"
        >
          <Form form={form} className='typeSelect-column-form'>
            {/* <SelectField
                onChange={(value: string) => handleFilterColumn(value, 'type')}
                options={typeList}
                className="column-select"
                placeholder={t("common.type")}
                onDropdownVisibleChange={onDropdownVisibleChange}
                transferType={true}
                name={"type_filter"} 
             /> */}
            <Form.Item
              name={"type_filter"}
              className="column-select"
            >
              <Select
                onDropdownVisibleChange={onDropdownVisibleChange}
                onMouseLeave={() => setHover(true)}
                onMouseEnter={() => setHover(false)}
                dropdownClassName={`${noHover ? "selectcolumn-transfer selectcolumntype-transfer typeSelect-column" : "hoverable selectcolumntype-transfer selectcolumn-transfer"}`}
                placeholder={t("common.type")}
                // transferType={true}
                style={{ width: "max-content" }}
                labelInValue
                optionLabelProp='label'
                // className={'selectcolumn-transfer'}
                autoClearSearchValue
                onChange={(value: string) => handleFilterColumn(value, 'type')}
              >
                {

                  typeList?.map((row: any, index: number) => {

                    return (
                      <Option key={index} value={row.value} >

                        <div
                        // style={{ width: 63 }}
                        >
                          {/*{row.title && <span className={'selectListTitle'}>{!openStatus ? row.title?.trim() : row.title}</span>}*/}
                          {<span
                          // className={'asdfg'}
                          >
                            {!selected ? row.label : row.value}
                            {row.status === "0" && <CustomTooltip title={t("transfers.closedAccount")}>
                              <img style={{ marginLeft: 30 }} src={errorStatus} />
                            </CustomTooltip>}
                          </span>

                          }
                        </div>
                        {/*{row.extra && (openStatus) && value !== row.value && <span>{row.extra}</span>}*/}
                      </Option>
                    )
                  })
                }
              </Select>
            </Form.Item>
          </Form>
        </div>
      ),
      dataIndex: 'type',
      key: 'type',
      width: 30,
      ellipsis: true,
      editable: false,
      render: (text: string) => {

        return (
          <CustomTooltip
            style={{ marginLeft: 5 }}
            className="table-tooltip"
            title={typeRender(text)}
            placement="top"
          >
            <p style={{
              textAlign: 'left',
              // position: 'relative',
              // right: 20,
            }}>{text}</p>
          </CustomTooltip>
        )
      },
    },
    {
      title: (
        <div
          className="searchable-column"
        // style={{ marginLeft: -44 }}
        >
          <div className={searchable ? 'bordered flex transferSorter' : 'flex transferSorter'}>
            <SortableColumn
              data={tableList}
              setData={setTableFilterList}
              dataOriginal={tableListForSortOriginal}
              type={"string"}
              parameter={"getter"}
            />
            <Form
              form={form}
              className={"transfer-form"}
            >
              <SearchableColumn

                large
                title={t("common.beneficiary")}
                form={form}
                name={"getter"}
                filter={"searchfilter"}
                onChange={(event: any) => handleFilterColumn(event, 'getter')}
                buttonClicked={buttonClicked}
              />
            </Form>
            {/* <SearchableColumn title={'Alan'} /> */}
          </div>
        </div>
      ),
      dataIndex: 'getter',
      key: 'getter',
      width: 242,
      ellipsis: true,
      editable: false,
      // sorter: (a: any, b: any) => a.getter.localeCompare(b.getter),
      render: (text: string) => {
        return text.length > 30 ? (
          <CustomTooltip className="table-tooltip" title={text}>
            <p>{text}</p>
          </CustomTooltip>
        ) : (
          <p>{text}</p>
        )
      },
    },
    {
      title: (
        <div className="searchable-column">
          <div className={searchable ? 'bordered flex transferSorter' : 'flex transferSorter'}>
            <SortableColumn
              data={tableList}
              setData={setTableFilterList}
              dataOriginal={tableListForSortOriginal}
              type={"string"}
              parameter={"assignment"}
            />
            <Form
              form={form}
              className={"transfer-form"}
            >
              <SearchableColumn
                large
                title={t("transfers.details")}
                form={form}
                name={"appointment"}
                filter={"searchfilter"}
                onChange={(event: any) => handleFilterColumn(event, 'appointment')}
                buttonClicked={buttonClicked}
              />
            </Form>
            {/* <SearchableColumn
              large
              title={t("transfers.details")}
              searchable={() => console.log(searchable)}
            /> */}
          </div>
        </div>
      ),
      dataIndex: 'assignment',
      key: 'assignment',
      width: 180,
      ellipsis: true,
      editable: false,
      // sorter: (a: any, b: any) => a.assignment.localeCompare(b.assignment),

      render: (text: string) => {
        const tempArray = text?.replaceAll(',', '<br>')

        return (
          text?.length < 30 ?
            <p>{text}</p> : <CustomTooltip
              className="table-tooltip"
              title={tempArray}
            >
              <p>{text.substring(0, 30) + "..."}</p>

            </CustomTooltip>

        )
      },
    },
    {
      title: (
        <div className="searchable-column">
          <div className={searchable ? 'bordered flex' : 'flex'}>
            <SortableColumn
              data={tableList}
              setData={setTableFilterList}
              dataOriginal={tableListForSortOriginal}
              type={"number"}
              parameter={"amount"}
            />
            <Form
              form={form}
              className={"transfer-form"}
            >
              <SearchableColumn
                large
                title={t("common.amount")}
                form={form}
                name={"ammount"}
                filter={"searchfilter"}
                onChange={(event: any) => handleFilterColumn(event, 'amount')}
                buttonClicked={buttonClicked}
              />
            </Form>
            {/* <SearchableColumn
              large
              title={t("common.amount")}
              searchable={() => console.log(searchable)}
            /> */}
          </div>
        </div>
      ),
      dataIndex: 'amount',
      key: 'amount',
      width: 138,
      minWidth: 138,
      ellipsis: true,
      editable: false,
      render: (text: string, record: any) => {

        return <p style={{ minWidth: 103, textAlign: 'right' }}>
          {text}
        </p>
      },
    },
    {
      title: (
        <div className="searchable-column flex select-column transfersCurrency-column">
          <Form form={form}>
            <Form.Item className="column-select">
              <Select
                placeholder={t("home.currency")}
                label
                options={currencyList}
                dropdownClassName={`${noHover ? "selectcolumn-transfer" : "hoverable selectcolumn-transfer"}`}
                // onChange={(value: string) => filterHandler(value, 'currency')}
                name={"currency_filter"}
                onChange={(value: string) => handleFilterColumn(value, 'currency')}
              />
            </Form.Item>
          </Form>
        </div>
      ),
      dataIndex: 'currency',
      key: 'currency',
      width: 70,
      ellipsis: true,
      editable: false,
      render: (text: string, record: any) => {

        return <p style={{ textAlign: 'center' }}>
          {text}
        </p>
      },
    },
    {
      title: (
        <>
          <p style={{ textAlign: 'left', color: '#747a83', fontSize: '12px' }}>
            Status
          </p>
        </>
      ),
      dataIndex: 'status',
      key: 'status',
      width: 107,
      editable: false,
      render: (record: any, text: string) => {
        return <div>{statusRender(record)}</div>
      },
    },
    // {
    //   title: 'account',
    //   dataIndex: 'customerAccount',
    // },
  ]

  let roleData = getRoleData()

   const handleRowClick = async (ibankKey: string, type: string) => {
    console.log('ll',type);
    
    setBtnDataModal({})
    setSelectedIbanRef("")
    const result: any = tableList.filter((cert) => cert.key === ibankKey)
    console.log("red1", result);
    if (result?.[0]?.status && result?.[0]?.status === "CLOSED") {
      console.log("red", result);
      setSelectedType("CLOSED");
    }
    // Show the SIMA-adoc button in the detail modal only for a CLOSED
    // transfer that carries a SIMA signature; hidden for anything else.
    const clickedRow: any = result?.[0]
    setSimaAdocModalVisible(
      clickedRow?.status === 'CLOSED' &&
      Array.isArray(clickedRow?.signDetailList) &&
      clickedRow.signDetailList.some((s: any) => s?.signType === 'SIMA')
    )
    if (result !== null && result.length > 0 && result[0].actionButtons !== undefined)
      setBtnDataModal(result[0].actionButtons)
    setShowSpinner(true)
    let detailData = await getTransfersDetail(ibankKey, language)
    setSelectedIbanRef(ibankKey)
    setRowClick(true)
    setModalType(type)
    setType1(type);
    let modalDataS = await modalRender(type, detailData)
    setModalDataSingle(modalDataS)
    setDetailData(detailData)
    setNoteList([])

    
    const cashHistory: Array<any> = []
    const errorHistory: Array<any> = []
    if (detailData !== undefined && detailData !== null) {
      detailData['HISTORY_DETAILS'].map((item: any) => {
        cashHistory.push({
          transactionDate: item.transactionDate + ' ' + item.transactionTime,
          userName: item.userName,
          trnRequestType: item.trnStatusBeforeStr,
          trnStatusAfter: item.trnStatusAfterStr
        });
        if(item.errorText !== null)
        {
          errorHistory.push({
          date:item.transactionDate+ " " +item.transactionTime,
          userName: item.userName,
          notification:item.errorText
        })
      }
      });
     
    }
     setNoteList(errorHistory);
    setHistoryList(cashHistory)
    // if (detailData['bankNote'] !== null) {
    //   const line = detailData['HISTORY_DETAILS'];
    //   if (line !== undefined && line !== null && detailData['HISTORY_DETAILS'].length > 0) {
    //     const listCount = detailData['HISTORY_DETAILS'].length - 1;

    //     const a = [{ date: detailData['HISTORY_DETAILS'][listCount]['transactionDate'] + " " + detailData['HISTORY_DETAILS'][listCount]['transactionTime'], userName: detailData['HISTORY_DETAILS'][listCount]['userName'], notification: detailData['bankNote'] }]
    //     setNoteList(a);
    //   }

    // }


    setShowSpinner(false)
    setMultiple(false)
    // setSelectedType(detailData['trnStatus'])
    setModalVisibility(true)
  }

  const handleDateData = (key: number) => {
    setCurrent(1)
    setDateIndex(key)
    setActiveClass(0)
  }

  const handleStatTabClick = (item: any, index: number) => {

    setBtnData({})
    setBtnDataModal({})
    const status = item['status']
    setSelectedType(status)
    setActiveClass(index)
    setCurrent(1)
    setChecked(false)
    setCheckedList([])
    setBtnStatus({})
    let formData = {
      startDate: formValue.startDate,
      endDate: formValue.endDate,
      account: formValue.account,
      status: formValue.status,
      filter: formValue.filter,
    }
    setMultiple(false)

    form.setFieldsValue({
      ['date_filter']: { label: t("common.all"), value: 'all' },
      ['type_filter']: { label: t("common.all"), value: 'all' },
      ['currency_filter']: { label: t("common.all"), value: 'all' },
    })
    setButtonClicked(buttonClicked + 1);
    // handleTransfersFilter(formData, index)
    // filterHandler(item.status, 'status')
  }

  const filterHandler = (value: string, columnName: string) => {
    // const data = checked ? tableData : tableList
    // const filtered = data.filter((row) => {
    //   return row[columnName] == value
    // })
    // setTableFilterList(value === 'ALL' ? tableData : filtered)

    // if (value == 'ALL') {
    //   form.resetFields(['currecy_filter'])
    // }
  }

  useEffect(() => {

    const fetchDataAccounts = async () => {
      let accounts = await getAccounts(getCurrentCompany())
      let selectAccountOptionsArr: Array<any> = []
      accounts.map((item: any) => {
        return selectAccountOptionsArr.push({
          // key: item.ibankRef,
          label: item.NICKNAME ? item.NICKNAME : item.IBAN,
          extra: financial(item.BALANCE) + ' ' + item.CCY_NAME,
          value: item.IBAN,
          status: item.STATUS,
        })
      })
      //@ts-ignore

      setAccountOptions(ALLOptions.concat(selectAccountOptionsArr))
    }

    fetchDataAccounts()
  }, [])



  const handleRefresh = () => {
    history.replace("/transfers/ALL")
    history.go(0)

    // setRefresh(!isRefresh)
    // setBtnData({})
    // setBtnDataModal({})
    // setDateIndex(1)
    // setStartDate(moment(moment(), 'DD.MM.YYYY'))
    // setEndDate(moment(moment(), 'DD.MM.YYYY'))
    // handleDateData(1)

    // form.setFieldsValue({
    //   ['date_filter']: { label: t("common.all"), value: 'all' },
    //   ['type_filter']: { label: t("common.all"), value: 'all' },
    //   ['currency_filter']: { label: t("common.all"), value: 'all' },
    // })
    setButtonClicked(buttonClicked + 1);
  }


  // useEffect(() => {
  //   setActiveClass(0)
  // }, [formValue])

  const statusParam = useParams()

  const typeRenderTransfer = (type: any) => {
    switch (type) {
      case 'IM':
        return t("transfers.internalToOwnAccount") + " (IM)"
      case 'IT':
        return t("templates.internalToOtherBank")
      case "FX":
        return t("home.currencyExchange") + " (FX)"
      case "AZ":
        return t("AZİPS" + " (AZ)")
      case "XO":
        return t("templates.XOKS")
      case "XT":
        return t("home.budgetSTA") + " (XT)"
      case "XV":
        return t("home.budgetVAT") + " (XV)"
      case "FP":
        return t("home.foreignCurrencyTransfer") + " (FP)"
      case "RP":
        return "RUB" + " (RP)"
      case "SP":
        return t("fastMenu.salaryTransfer") + " (SP)"
      case "PI":
        return t("transfers.anipayNonBudget") + " (PI)"
      case "PV":
        return t("transfers.aniPayVAT") + " (PV)"
      case "PT":
        return t("transfers.aniPaySTA") + " (PT)"
      case "GP":
        return t('transfers.gpp') + " (GP)"
      default:
        return '';
    }

  }
  const buildCurrencyList = (rows: any[]) => {
    const list = [{ label: t("common.all"), value: "all" }];

    rows.forEach((row) => {
      const curr = row.currency || row.pmtCurr;
      if (!curr) return;

      const exists = list.find(item => item.value === curr);
      if (!exists) {
        list.push({ label: curr, value: curr });
      }
    });

    return list;
  };
  const fetchData = async () => {

    setTableLoading({
      ...tableLoading,
      spinning: true
    });
    let transfersData
    let countData: Array<any> = []
    let filterByStatus: Array<any> = []
    if ((formValue && formValue.length !== 0 && activeIndexDate !== 1) || (Object.values(statusParam)[0] === 'ALL' && tableListCash?.length > 0 && btnCount?.length > 0)) {
      transfersData = tableListCash
      countData = btnCount

      // let formData = {}
      //    formData = {
      //     startDate: formValue.startDate,
      //     endDate: formValue.endDate,
      //   }
      // countData = await getTransfersStatusCount(formData, businessDate)
      // //@ts-ignore
      // transfersData = await getTransfersFiltered(businessDate,  formData, 1)
    }
    else if (Object.values(statusParam)[0] && Object.values(statusParam)[0] !== 'ALL') {

      const businessDateData = await getBusinessDate(language)
      setBusinessDate(businessDateData)
      let statusData = Object.values(statusParam)[0]
      let formDataValues = {}
      if (statusData == 'DELETED' || statusData == 'CLOSED') {
        formDataValues = {
          status: statusData,
          startDate: moment(),
          // endDate: businessDateData
        }
        // // setEndDate(moment())
        setDateIndex(1)
        setStartDate(moment())
        setEndDate(moment(businessDateData, "DD.MM.YYYY"))
      } else if (statusData == 'BANK_REJECTED' || statusData == 'EXPIRED') {
        formDataValues = {
          status: statusData,
          startDate: moment(),
          // endDate: businessDateData
        }
        // // setEndDate(moment())
        setDateIndex(1)
        setStartDate(moment())
        setEndDate(moment(businessDateData, "DD.MM.YYYY"))
      } else {
        setDateIndex(0)
        formDataValues = {
          status: statusData,
          startDate: moment(businessDateData, "DD.MM.YYYY").subtract(15, "days"),
          // endDate: businessDateData
        }
        setEndDate(moment(businessDateData, "DD.MM.YYYY"))
        setStartDate(moment(businessDateData, "DD.MM.YYYY").subtract(15, "days"))
      }


      countData = await getTransfersStatusCount(formDataValues, businessDateData)
      if (countData[0] !== undefined) {
        const status = countData[0]['status'];
        setSelectedType(status)
      }
      //@ts-ignore
      let pack_arr: any = [{ label: t("common.all"), value: 'all' }]

      transfersData = await getTransfersFiltered(businessDateData, formDataValues, 1, language)
      transfersData.map((r) => {
        console.log("e", r);

        let check_packages = pack_arr.find(row => row.value == r?.batchName)
        if (!check_packages && r.batchName !== null && r.packageNumber !== null) {


          pack_arr.push({
            label: r.packageNumber + " " + "(" + r?.batchName + ")",
            value: r?.batchName
          })

        }
      })
      setPackages(pack_arr)
    }
    else {
      const businessDateData = await getBusinessDate(language)
      setBusinessDate(businessDateData);
      setEndDate(moment(businessDateData, "DD.MM.YYYY"));
      setStartDate(moment())
      let formDataValues = {}
      formDataValues = {
        startDate: moment(),
        endDate: moment(businessDateData, "DD.MM.YYYY"),
      }
      //@ts-ignore
      countData = await getTransfersStatusCount(formDataValues, businessDateData)

      // if (countData[0] !== undefined) {
      //   const status = countData[0]['status']
      //   console.log("isledi fetch")
      //   console.log(status)
      //   setSelectedType(status)
      // }
      //@ts-ignore
      let pack_arr: any = [{ label: t("common.all"), value: 'all' }]

      transfersData = await getTransfers(moment(formDataValues.startDate), businessDateData, 1, language)
      transfersData.map((r) => {
        console.log("e", r);

        let check_packages = pack_arr.find(row => row.value == r?.batchName)
        if (!check_packages && r.batchName !== null && r.packageNumber !== null) {


          pack_arr.push({
            label: r.packageNumber + " " + "(" + r?.batchName + ")",
            value: r?.batchName
          })

        }
      })
      setPackages(pack_arr)
    }

    let temp_array: Array<any> = []
    let temp_dates = [{ label: t("common.all"), value: 'all' }];
    let temp_types = [{ label: t("common.all"), value: 'all' }];
    let temp_currency = [{ label: t("common.all"), value: 'all' }];
    let source_Array = [{ label: t("common.all"), value: 'all' }];
    let packages_array = [{ label: t("common.all"), value: 'all' }];
    setTableListCash(transfersData);
    transfersData.map((item) => {
      let filter_date = dateFormatter(item.trnDateTime, "DD.MM.YYYY");

      let check_date = temp_dates.find(row => row.value == filter_date);

      if (!check_date) {
        temp_dates.push({ label: filter_date, value: filter_date })
      }
      let check_source = source_Array.find(row => row.value == item?.allSource)
      if (!check_source && item.allSource !== null) {
        source_Array.push({
          label: item?.allSource !== 'BT' ? (item?.allSource === 'API' ? "API" : item?.allSource === 'MOBILE' ? 'MO' : "IO") : 'BT',
          value:
            // (item?.allSource ==='MOBILE' ? 'MO' :
            item?.allSource
          // )
        })

      }
      let check_packages = packages_array.find(row => row.value == item?.batchName)
      if (!check_packages && item.batchName !== null) {
        packages_array.push({
          label: item?.batchName,
          value: item?.batchName
        })

      }


      let check_type = temp_types.find(row => row.value == item.brTrnType);

      if (!check_type) {
        temp_types.push({ label: item.brTrnType, value: item.brTrnType })
      }

      let check_currency = temp_currency.find(row => row.value == item.pmtCurr || item.currency);

      if (!check_currency) {
        temp_currency.push({ label: item.pmtCurr || item.currency, value: item.pmtCurr || item.currency })
      }

      return temp_array.push({
        key: item.ibankRef,
        date: item.trnDateTime,
        user: item?.lastUser,
        lastUserName: item.lastUserName,
        type: item.brTrnType,
        getter: item.benefName ? item.benefName : '',
        assignment: item.description,
        currency: item.pmtCurr || item.currency,
        amount: financial(item.amount),
        status: item.status,
        pmtCustId: item.pmtCustId,
        signAvailable: item.signAvailable,
        approveAvailable: item.approveAvailable,
        customerAccount: item.customerAccount,
        commamount: item.commamount,
        actionButtons: item.actionButtons,
        allSource: item.source,
        batchName: item.batchName,
        info:item.infoToBenef,
        signDetailList: item.signDetailList
      })
    })
    let cntBtn: Array<any> = []
    if (countData !== undefined) {
      countData.map((item) => {
        const name = statusRender(item.status);
        if (name !== null) {
          cntBtn.push(item)
        }
      })
    }
    setBtnCount(cntBtn)
    let countSign = temp_array.filter(
      (obj) => obj.signAvailable === 'true' || obj.approveAvailable === 'true'
    ).length
    setForSign(countSign)
    if (checked.toString() === 'true') {
      let temp_dates = [{ label: t("common.all"), value: 'all' }];
      let temp_types = [{ label: t("common.all"), value: 'all' }];
      let temp_currency = [{ label: t("common.all"), value: 'all' }];
      let source_Array = [{ label: t("common.all"), value: 'all' }];
      let packages_array = [{ label: t("common.all"), value: 'all' }];
      const filtered = temp_array.filter((row) => {
        if (row['signAvailable'] == 'true' || row['approveAvailable'] == 'true') {
          let filter_date = dateFormatter(row.date, "DD.MM.YYYY");

          let check_date = temp_dates.find(row => row.value == filter_date);

          if (!check_date) {
            temp_dates.push({ label: filter_date, value: filter_date })
          }
          let check_source = source_Array.find(item => item.value == row?.allSource)
          if (!check_source && row.allSource !== null) {
            source_Array.push({
              label: row?.allSource !== 'BT' ? (row.allSource === 'API' ? "API" : row.allSource === 'MOBILE' ? 'MO' : "IO") : 'BT',
              value: row?.allSource
            })
          }



          let check_type = temp_types.find(item => item.value == row.type);

          if (!check_type) {
            temp_types.push({ label: typeRenderTransfer(row.type), value: row.type })
          }
          let check_packages = packages_array.find(row => row.value == row?.batchName)
          if (!check_packages && row.batchName !== null) {
            packages_array.push({
              label: row?.batchName,
              value: row?.batchName
            })

          }
          let check_currency = temp_currency.find(item => item.value == row.pmtCurr || row.currency);



          if (!check_currency) {
            temp_currency.push({ label: row.pmtCurr || row.currency, value: row.pmtCurr || row.currency })
          }
        }
        return row['signAvailable'] == 'true' || row['approveAvailable'] == 'true'
      })
      setTableFilterList(filtered)
      setTableFilterListForFilter(filtered)
      setTableListForSortOriginal(filtered)
      setDateList(temp_dates)
      // setPackages(packages_array)
      setTypeList(temp_types)
      setTransferData(source_Array)
      setCurrencyList(buildCurrencyList(filtered));
    }
    else if (cntBtn.length > 0) {
      let index = cntBtn.length == 1 ? 0 : activeIndex
      let temp_dates = [{ label: t("common.all"), value: 'all' }];
      let temp_types = [{ label: t("common.all"), value: 'all' }];
      let temp_currency = [{ label: t("common.all"), value: 'all' }];
      let source_Array = [{ label: t("common.all"), value: 'all' }];
      let packages_array = [{ label: t("common.all"), value: 'all' }];
      filterByStatus = temp_array.filter(
        (obj) => {
          if (obj.status == cntBtn[index].status.toString()) {
            let filter_date = dateFormatter(obj.date, "DD.MM.YYYY");

            let check_date = temp_dates.find(row => row.value == filter_date);

            if (!check_date) {
              temp_dates.push({ label: filter_date, value: filter_date })
            }

            let check_source = source_Array.find(row => row.value == obj?.allSource)

            if (!check_source && obj.allSource !== null) {
              source_Array.push({
                label: obj.allSource !== 'BT' ? (obj.allSource === 'API' ? "API" : obj.allSource === 'MOBILE' ? 'MO' : "IO") : 'BT',
                value: obj?.allSource
              })

            }


            let check_type = temp_types.find(item => item.value == obj.type);

            if (!check_type) {
              temp_types.push({ label: typeRenderTransfer(obj.type), value: obj.type })
            }
            let check_packages = packages_array.find(row => row.value == obj?.batchName)
            if (!check_packages && obj.batchName !== null) {
              packages_array.push({
                label: obj?.batchName,
                value: obj?.batchName
              })

            }
            let check_currency = temp_currency.find(item => item.value == obj.pmtCurr || obj.currency);

            if (!check_currency) {
              temp_currency.push({ label: obj.pmtCurr || obj.currency, value: obj.pmtCurr || obj.currency })
            }
          }
          return obj.status == cntBtn[index].status.toString()
        }
      )
      setTableFilterList(filterByStatus)
      setTableFilterListForFilter(filterByStatus)
      setTableListForSortOriginal(filterByStatus)
      setDateList(temp_dates)
      // setPackages(packages_array)
      setTypeList(temp_types)
      setTransferData(source_Array)
      setCurrencyList(buildCurrencyList(filterByStatus));
    }
    else {
      setTableFilterList(temp_array)
      setTableFilterListForFilter(temp_array)
      setTableListForSortOriginal(temp_array)
      setDateList(temp_dates)
      // setPackages(packages_array)
      setTypeList(temp_types)
      setTransferData(source_Array)
      setCurrencyList(buildCurrencyList(temp_array));
    }
    setTableLoading({
      ...tableLoading,
      spinning: false
    });
  }

  useEffect(() => {
    setCurrent(1)
    setBtnData({})
    setBtnDataModal({})
    fetchData()
  }, [location.pathname, checked, isRefresh, activeIndex])


  useEffect(() => {

    if (Object.keys(sourceComingPage).length === 0 && location.pathname.substring(location.pathname.lastIndexOf('/') + 1) !== 'ALL') {
      history.replace("/transfers/ALL")
      history.go(0)
    }
  }, [location])

  useEffect(() => {
    let simaAdocEnabled = false
    tableList.map((item: any) => {
      if (item.key == selectedRowKeys[0] && selectedRowKeys.length == 1) {
        if (item.status == 'PENDING_SIGNER' || item.status == 'PENDING_APPROVER' || item.status == 'PENDING_ALL') {
          setDeleteDisable(false)
          setEditDisable(false)
        } else if (item.status == 'CLOSED') {
          setAdocDisable(false)
          setSelectedType(item.status)
        }
        if (
          item.status == 'CLOSED' &&
          Array.isArray(item.signDetailList) &&
          item.signDetailList.some((s: any) => s?.signType === 'SIMA')
        ) {
          simaAdocEnabled = true
        }
      }
      if (selectedRowKeys.length == 0 || selectedRowKeys.length > 1 || (item.status !== 'PENDING_SIGNER' || item.status == 'PENDING_APPROVER' || item.status == 'PENDING_ALL')) {
        setDeleteDisable(true)
        setEditDisable(true)
        setAdocDisable(true)
      }
    })
    setSimaAdocDisable(!simaAdocEnabled)
  }, [selectedRowKeys])

  // useEffect(() => {
  //   btnCount.length < (activeIndex +1) &&  setActiveClass(0)
  // }, [btnCount])

  const handleTransfersFilter = async (args: any, activeIndexNum: number) => {
    setBtnData({})
    setBtnDataModal({})
    setActiveClass(0)
    setCurrent(1)
    setArguments(args)
    form.setFieldsValue({
      ['date_filter']: { label: t("common.all"), value: 'all' },
      ['type_filter']: { label: t("common.all"), value: 'all' },
      ['currency_filter']: { label: t("common.all"), value: 'all' },
    })
    setButtonClicked(buttonClicked + 1);

    history.replace('/transfers/ALL')
    setTableLoading({
      ...tableLoading,
      spinning: true
    }); 
    const data = await getLoggedUserInfo()
    
    console.log("data", data)
 let phone_number = data?.phoneNumber;
            let last_4_number = phone_number?.slice(-4)
            let make_phone_number = last_4_number && last_4_number.length >= 4
              ? last_4_number[0] + last_4_number[1] + '-' + last_4_number.slice(-2)
              : ''

            setOtpNumberCount((old_number) => (channel === 'TOTP' ? 6 : 5))
            setPhoneNumber((old_data) => make_phone_number)
    
    const fetchData = async () => {
      let transfersData: Array<any> = []
      let countData: Array<any> = []
      let filterByStatus: Array<any> = []
      args.startDate ? setStartDate(moment(args.startDate)) : setStartDate(moment(moment(), 'DD.MM.YYYY'))
      args.endDate ? setEndDate(moment(args.endDate)) : setEndDate(moment(businessDate, "DD.MM.YYYY"))
      
      // setEndDate(endDateData)
      // setStartDate(startDateData)
      const limitDate = moment().subtract(180, 'days').startOf('day');
      const isOldDate = moment(args.startDate, "DD.MM.YYYY").isBefore(limitDate) ||
      moment(args.endDate, "DD.MM.YYYY").isBefore(limitDate);
     
      
     if(false){
        setOtpCodeModalVisibleTrList(true)
        setOtpCodeHasErrorTrList(false)
        setOtpCodeTrList('')
        setErrorText('')
        transfersData = await getTransfersFiltered(businessDate, args, 1, language)
     }
      else{ 
        countData = await getTransfersStatusCount(args, businessDate)
      if (countData[0] !== undefined) {
        const status = countData[0]['status']
        setSelectedType(status)
      }
      let packages_array = [{ label: t("common.all"), value: 'all' }];
      let pack_arr: any = [{ label: t("common.all"), value: 'all' }]
      transfersData = await getTransfersFiltered(businessDate, args, 1, language)

      transfersData.map((r) => {
        console.log("e", r);

        let check_packages = pack_arr.find(row => row.value == r?.batchName)
        if (!check_packages && r.batchName !== null && r.packageNumber !== null) {


          pack_arr.push({
            label: r.packageNumber + " " + "(" + r?.batchName + ")",
            value: r?.batchName
          })

        }
      })
      setPackages(pack_arr)
      let temp_array: Array<any> = []
      let temp_dates = [{ label: t("common.all"), value: 'all' }];
      let temp_types = [{ label: t("common.all"), value: 'all' }];
      let temp_currency = [{ label: t("common.all"), value: 'all' }];
      let source_Array = [{ label: t("common.all"), value: 'all' }];
      setTableListCash(transfersData);
      transfersData.map((item) => {
        let check_source = source_Array.find(row => row.value == item?.allSource)
        if (!check_source) {
          console.log(item.source)
          source_Array.push({
            label: item.allSource !== 'BT' ? (item.allSource === 'API' ? "API" : item.allSource === 'MOBILE' ? 'MO' : "IO") : 'BT',
            value: item?.allSource
          })

        }
        let filter_date = dateFormatter(item.trnDateTime, "DD.MM.YYYY");

        let check_date = temp_dates.find(row => row.value == filter_date);

        if (!check_date) {
          temp_dates.push({ label: filter_date, value: filter_date })
        }
        let check_packages = packages_array.find(row => row.value == item?.batchName)
        if (!check_packages && item.batchName !== null) {
          packages_array.push({
            label: item?.batchName,
            value: item?.batchName
          })

        }
        let check_type = temp_types.find(row => row.value == item.brTrnType);

        if (!check_type) {
          temp_types.push({ label: typeRenderTransfer(item.brTrnType), value: item.brTrnType })
        }

        let check_currency = temp_currency.find(row => row.value == item.pmtCurr || item.currency);

        if (!check_currency) {
          temp_currency.push({ label: item.pmtCurr || item.currency, value: item.pmtCurr || item.currency })
        }


        return temp_array.push({
          key: item.ibankRef,
          date: item.trnDateTime,
          user: item?.lastUser,
          lastUserName: item.lastUserName,
          type: item.brTrnType,
          getter: item.benefName ? item.benefName : '',
          assignment: item.description,
          currency: item.pmtCurr || item.currency,
          amount: financial(item.amount),
          status: item.status,
          pmtCustId: item.pmtCustId,
          signAvailable: item.signAvailable,
          approveAvailable: item.approveAvailable,
          customerAccount: item.customerAccount,
          actionButtons: item.actionButtons,
          allSource:item.source,
          batchName:item.batchName,
          info:item.infoToBenef,
          signDetailList: item.signDetailList
        })
      })
      let cntBtn: Array<any> = []
      if (countData !== undefined) {
        countData.map((item) => {
          const name = statusRender(item.status);
          if (name !== null) {
            cntBtn.push(item)
          }
        })
      }
      setBtnCount(cntBtn)
      let countSign = temp_array.filter(
        (obj) => obj.signAvailable === 'true' || obj.approveAvailable == 'true'
      ).length
      setForSign(countSign)
      if (checked.toString() === 'true') {
        let temp_dates = [{ label: t("common.all"), value: 'all' }];
        let temp_types = [{ label: t("common.all"), value: 'all' }];
        let temp_currency = [{ label: t("common.all"), value: 'all' }];
        let source_Array = [{ label: t("common.all"), value: 'all' }];
        let packages_array = [{ label: t("common.all"), value: 'all' }];

        const filtered = temp_array.filter((row) => {
          if (row['signAvailable'] == 'true' || row['approveAvailable'] == 'true') {
            let filter_date = dateFormatter(row.date, "DD.MM.YYYY");

            let check_date = temp_dates.find(row => row.value == filter_date);

            if (!check_date) {
              temp_dates.push({ label: filter_date, value: filter_date })
            }
            let check_source = source_Array.find(item => item.value == row?.allSource)
            if (!check_source) {
              source_Array.push({
                label: row.allSource !== 'BT' ? (row.allSource === 'API' ? "API" : row.allSource === 'MOBILE' ? 'MO' : "IO") : 'BT',
                value: row?.allSource
              })
            }
            let check_type = temp_types.find(item => item.value == row.type);

            if (!check_type) {
              temp_types.push({ label: typeRenderTransfer(row.type), value: row.type })
            }

            let check_packages = packages_array.find(row => row.value == row?.batchName)
            if (!check_packages && row.batchName !== null) {
              packages_array.push({
                label: row?.batchName,
                value: row?.batchName
              })

            }
            let check_currency = temp_currency.find(item => item.value == row.pmtCurr || row.currency);

            if (!check_currency) {
              temp_currency.push({ label: row.pmtCurr || row.currency, value: row.pmtCurr || row.currency })
            }
          }
          return row['signAvailable'] == 'true' || row['approveAvailable'] == 'true'
        })

        setTableFilterList(filtered)
        setTableFilterListForFilter(filtered)
        setTableListForSortOriginal(filtered)
        setDateList(temp_dates)
        // setPackages(packages_array)

        setTransferData(source_Array)
        setTypeList(temp_types)
        setCurrencyList(buildCurrencyList(filtered));
      }
      else if (cntBtn.length > 0) {
        let index = cntBtn.length == 1 ? 0 : activeIndexNum
        let temp_dates = [{ label: t("common.all"), value: 'all' }];
        let temp_types = [{ label: t("common.all"), value: 'all' }];
        let temp_currency = [{ label: t("common.all"), value: 'all' }];
        let source_Array = [{ label: t("common.all"), value: 'all' }];
        let packages_array = [{ label: t("common.all"), value: 'all' }];

        filterByStatus = temp_array.filter(
          (obj) => {
            if (obj.status == cntBtn[index].status.toString()) {

              let filter_date = dateFormatter(obj.date, "DD.MM.YYYY");

              let check_date = temp_dates.find(row => row.value == filter_date);

              if (!check_date) {
                temp_dates.push({ label: filter_date, value: filter_date })
              }
              let check_source = source_Array.find(row => row.value == obj?.allSource)

              if (!check_source) {
                source_Array.push({
                  label: obj.allSource !== 'BT' ? (obj.allSource === 'API' ? "API" : obj.allSource === 'MOBILE' ? 'MO' : "IO") : 'BT',
                  value: obj?.allSource
                })

              }
              let check_type = temp_types.find(item => item.value == obj.type);

              if (!check_type) {
                temp_types.push({ label: typeRenderTransfer(obj.type), value: obj.type })
              }
              let check_packages = packages_array.find(row => row.value == obj?.batchName)
              if (!check_packages && obj.batchName !== null) {

                packages_array.push({
                  label: obj?.batchName,
                  value: obj?.batchName
                })

              }
              let check_currency = temp_currency.find(item => item.value == obj.pmtCurr || obj.currency);

              if (!check_currency) {
                temp_currency.push({ label: obj.pmtCurr || obj.currency, value: obj.pmtCurr || obj.currency })
              }
            }
            return obj.status == cntBtn[index].status.toString()
          }
        )

        setTableFilterList(filterByStatus)
        setTableFilterListForFilter(filterByStatus)
        setTableListForSortOriginal(filterByStatus)

        // setPackages(packages_array)
        setDateList(temp_dates)
        setTypeList(temp_types)
        setTransferData(source_Array)
        setCurrencyList(buildCurrencyList(filterByStatus));
      }
      else {
        setTableFilterList(temp_array)
        setTableFilterListForFilter(temp_array)
        setTableListForSortOriginal(temp_array)

        // setPackages(packages_array)
        setDateList(temp_dates)
        setTypeList(temp_types)
        setTransferData(source_Array)

        setCurrencyList(buildCurrencyList(temp_array));
      }}
      setTableLoading({
        ...tableLoading,
        spinning: false
      });
    }

    const buildCurrencyList = (rows: any[]) => {
      const list = [{ label: t("common.all"), value: "all" }];

      rows.forEach((row) => {
        const curr = row.currency || row.pmtCurr;
        if (!curr) return;

        const exists = list.find(item => item.value === curr);
        if (!exists) {
          list.push({ label: curr, value: curr });
        }
      });

      return list;
    };
    fetchData()
  }

  const itemsRub = [
    {
      label: 'Договор',
      value: 'Dogov',
      code: 'ДОГОВ'
    },
    {
      label: 'Инвойс',
      value: 'Inv',
      code: 'ИНВ'
    },
    {
      label: 'Заказ на закупку',
      value: 'Zakaz na zakupku',
      code: 'ЗАК.НА ЗАКУПКУ'
    },
    {
      label: 'Дебетовое авизо',
      value: 'Debet.avizo',
      code: 'ДЕБЕТ.АВИЗО'
    },
    {
      label: 'Декларация',
      value: 'Dekl',
      code: 'ДЕКЛ'
    },
    {
      label: 'Письмо',
      value: 'Pisxmo',
      code: 'ПИСЬМО'
    },
    {
      label: "Решение учредителей",
      value: "Req.ucreditelei",
      code: 'РЕШ.УЧРЕДИТ.'
    },
    {
      label: "Решение суда",
      value: "Req.suda",
      code: 'РЕШ.СУДА'
    }, {
      label: "Док., подтверждающий поступл. средств",
      value: "Dok.o postupl.sredstv",
      code: 'ДОК.О ПОСТУПЛ.СРЕДСТВ'
    },
  ];
  const items = [
    {
      label: 'Contract',
      value: 'Contract',
      code: 'CNT',
      key: 1,
    },
    {
      label: 'Invoice',
      value: 'Invoice',
      code: 'INV',
      key: 2,
    },
    {
      label: 'Purchase Order',
      value: 'Purchase Order',
      code: 'PO',
      key: 3,
    },
    {
      label: 'Debit Note',
      value: 'Debit Note',
      code: 'DN',
      key: 4,
    },
    {
      label: 'GB',
      value: 'GB',
      code: 'GB',
      key: 5,
    },
    {
      label: 'Letter',
      value: 'Letter',
      code: 'LETTER',
      key: 6,
    },
    {
      label: "Shareholders' resolution",
      value: "Shareholders' resolution",
      code: 'SHAREHOLD.RESOL',
      key: 7,
    },
    {
      label: "Court's decision",
      value: "Court's decision",
      code: 'COURT.DECIS',
      key: 8,
    },
    {
      label: "Incoming SWIFT",
      value: "Incoming SWIFT",
      code: 'INC.SWIFT',
      key: 9,
    },
  ];
  const onSelectChange = async (checkedList: Array<String>) => {
    // console.log(checkedList)
    setMultiple(false)
    setBtnData({})
    setBtnDataModal({})
    setCheckedList(checkedList)
    console.log(checkedList.length)
    if (checkedList.length === 0) {
      setDocumentDetail([]);
      setType("common");
      setType1("common");
    }
    const result = tableList.filter((cert) => {
      let arr = checkedList.filter((detail) => detail === cert.key)
      return !(arr.length === 0)
    })

    if (result.length > 0 && result.length < 2) {

      if (result[0].actionButtons !== undefined) {
        setBtnData(result[0].actionButtons)
      }

      const btn = buttonStatusSingle[selectedType]
      if (btn !== undefined)
        //  && roleData !== 1)
        setBtnStatus(btn)
      else {
        const btn = buttonStatusSingle["ALL"]
        setBtnStatus(btn)
        if (roleData === 1 && selectedType === "CLOSED") {
          btnStatus['adoc'] = true;
          // btnStatus['swift'] = true;
        }
      }
      if (result[0]['type'] === "SP") {
        btnStatus['excell'] = true;
      }
    }
    else if (result.length > 1) {

      if (checked) {

        if (result[0].actionButtons !== undefined) {
          const cashBtn = result[0].actionButtons;
          // cashBtn['editButton'] = false;
          // cashBtn['repeatButton'] = false;
          setBtnData(cashBtn)
        }
        const btn = buttonStatusSingle[selectedType]
        if (btn !== undefined)
          //  && roleData !== 1)
          setBtnStatus(btn)
        // setBtnData(btn)
      }
      else if 
      // (roleData !== 1 &&
        ( selectedType.startsWith("PENDING")) {
        const btn = buttonStatusGroup["PENDING"]

        setBtnStatus(btn)
        setBtnData(btn)
      }
      else {
        const btn = buttonStatusGroup["ALL"]
        setBtnStatus(btn)
        setBtnData(btn)
      }
    }
    else {
      setBtnStatus({})
    }
    setFilteredTableData(result)
    if (checkedList[0] !== undefined) {
      let temp_detail_arr: any = []
      let detailData = await getTransfersDetail(checkedList[0], language)
      detailData?.transferDocs?.map((row, index) => {
        if (detailData?.trnType === 'SWIFT') {
          temp_detail_arr.push({
            "key": index + 1,
            "docId": row.docId,
            "docName": row.docName,
            "docNameLabel": items.find((r) => r.value === row.docName)?.label,
            "docNumAbsent": row.docNumAbsent === 'true' ? true : false,
            "docNum": row.docNum,
            "docDate": moment(row.docDate).format('MM.DD.YYYY'),
            "docNote": row.docNote,
            "isUsed": true
          })
        } else {
          temp_detail_arr.push({
            "key": index + 1,
            "docId": row.docId,
            "docName": row.docName,
            "docNameLabel": itemsRub.find((r) => r.value === row.docName)?.label,
            "docNumAbsent": row.docNumAbsent === 'true' ? true : false,
            "docNum": row.docNum,
            "docDate": moment(row.docDate).format('MM.DD.YYYY'),
            "docNote": row.docNote,
            "isUsed": true
          })
        }
      })

      setDocumentDetail(temp_detail_arr)
      setType(detailData?.trnType)
    }

  }
  const handleRepeat = async () => {
    if (selectedIbanRef !== "") {
      const result = await getTrannsferByIban(selectedIbanRef)
      tableList.map((item: any) => {
        if (item.key == selectedIbanRef) {
          let type = redirectPage(item.type)
          history.push(`${type}`, { data: result })
        }
      })
    } else {
      const result = await getTrannsferByIban(selectedRowKeys[0])
      tableList.map((item: any) => {
        if (item.key == selectedRowKeys[0]) {
          let type = redirectPage(item.type)
          history.push(`${type}`, { data: result })
        }
      })
    }
  }

  const handleDelete = async () => {
    setVisibleDeleteModal(true);
  }

  const handleEdit = async () => {
    if (selectedIbanRef !== "") {
      const result = await getTrannsferByIban(selectedIbanRef)
      tableList.map((item: any) => {
        if (item.key == selectedIbanRef) {
          let type = redirectPage(item.type)
          history.push(`${type}`, { data: result, edit: true })
        }
      })
    } else {
      const result = await getTrannsferByIban(selectedRowKeys[0])
      tableList.map((item: any) => {
        if (item.key == selectedRowKeys[0]) {
          let type = redirectPage(item.type)
          history.push(`${type}`, { data: result, edit: true })
        }
      })
    }
  }

  const handleDeleteCallBackApi = async (value) => {

    const desc = value['DELETEDNOTE'];
    let req = [];
    let req_result = [];
    let result = null
    if (selectedIbanRef !== "") {
      result = await getTrannsferByIban(selectedIbanRef)
      req.push({
        "ibankref": selectedIbanRef
      })
      req_result.push(result)
    } else {
      for (const item in selectedRowKeys) {
        result = await getTrannsferByIban(selectedRowKeys[item])
        console.log(result)
        req_result.push(result)
        const value = {
          "ibankref": selectedRowKeys[item]
        }
        req.push(value)
      }
    }

    const data = await deleteTransferNew(req, desc);
    if (req_result.filter((e) => e.isChainTransaction === "true").length > 0) {
      setChainModalConnect(true)
    }
    return data;
  }

  const reLoadData = () => {
    setTableListCash([])
    setBtnCount([])
    setDateIndex(1)
    setActiveClass(0)
    setCheckedList([])
    setSelectedIbanRef("")
    setDetailData({})
    setRefresh(!isRefresh)
    // if (selectedIbanRef !== "") {
    //   setTableFilterList((tableList) => tableList.filter((index) => index.key !== selectedIbanRef));
    // } else {
    //   for (const item in selectedRowKeys) {
    //     setTableFilterList((tableList) => tableList.filter((index) => index.key !== selectedRowKeys[item]));
    //   }
    // }
  }

  const [filtereValues, setFilteredValues] = useState({ "col_1": "", "col_2": "", "col_3": "", "col_4": "", "col_5": "", "col_6": "", "col_7": "", })

  const handleFilterColumn = (e: any, column: string) => {

    let newfiltereValues = filtereValues;
    if (column === 'allSource') {
      newfiltereValues.col_1 = e?.toLowerCase()
      newfiltereValues.col_2 = ''
      newfiltereValues.col_3 = ''
      newfiltereValues.col_4 = ''
      newfiltereValues.col_5 = ''
      newfiltereValues.col_6 = ''
      newfiltereValues.col_7 = ''
      form.setFieldsValue({ "user": "" })
      form.setFieldsValue({ "getter": "" })
      form.setFieldsValue({ "date_filter": undefined })
      form.setFieldsValue({ "currency": "" })
      form.setFieldsValue({ "appointment": "" })
      form.setFieldsValue({ "ammount": "" })
      setFilteredValues(newfiltereValues)
      setSelected(true)
      // setValue(e?.toLowerCase())
      // setDate(undefined)
    }

    if (column === 'date') {
      console.log(e)
      newfiltereValues.col_1 = ''
      if (e === 'all') {
        newfiltereValues.col_2 = ''
        setDate('')


      } else {
        newfiltereValues.col_2 = e?.toLowerCase()

      }
      newfiltereValues.col_3 = ''
      newfiltereValues.col_4 = ''
      newfiltereValues.col_5 = ''
      newfiltereValues.col_6 = ''
      newfiltereValues.col_7 = ''
      form.setFieldsValue({ "user": "" })
      form.setFieldsValue({ "allSource": "" })
      form.setFieldsValue({ "type_filter": null })
      form.setFieldsValue({ "getter": "" })
      form.setFieldsValue({ "currency": "" })
      form.setFieldsValue({ "appointment": "" })
      form.setFieldsValue({ "ammount": "" })
      setFilteredValues(newfiltereValues)
      setDate(e?.toLowerCase())

    }




    if (column === 'type') {
      newfiltereValues.col_1 = ''
      newfiltereValues.col_2 = ''
      newfiltereValues.col_3 = e?.value.toLowerCase()
      newfiltereValues.col_4 = ''
      newfiltereValues.col_5 = ''
      newfiltereValues.col_6 = ''
      newfiltereValues.col_7 = ''
      form.setFieldsValue({ "user": "" })
      form.setFieldsValue({ "allSource": "" })
      form.setFieldsValue({ "getter": "" })
      form.setFieldsValue({ "date_filter": undefined })

      form.setFieldsValue({ "currency": "" })
      form.setFieldsValue({ "appointment": "" })
      form.setFieldsValue({ "ammount": "" })
      setFilteredValues(newfiltereValues)
      setSelected(true)
      setDate('')

      // setValue(e?.toLowerCase())
    }

    if (column === 'getter') {
      newfiltereValues.col_1 = ''
      newfiltereValues.col_2 = ''
      newfiltereValues.col_3 = ''
      newfiltereValues.col_4 = e.target.value?.toLowerCase()
      newfiltereValues.col_5 = ''
      newfiltereValues.col_6 = ''
      newfiltereValues.col_7 = ''
      form.setFieldsValue({ "allSource": "" })
      form.setFieldsValue({ "type_filter": null })
      form.setFieldsValue({ "date_filter": undefined })

      form.setFieldsValue({ "currency": "" })
      form.setFieldsValue({ "appointment": "" })
      form.setFieldsValue({ "ammount": "" })
      setDate('')

      setFilteredValues(newfiltereValues)
    }

    if (column === 'appointment') {
      newfiltereValues.col_1 = ''
      newfiltereValues.col_2 = ''
      newfiltereValues.col_3 = ''
      newfiltereValues.col_5 = e.target.value?.toLowerCase()
      newfiltereValues.col_4 = ''
      newfiltereValues.col_6 = ''
      newfiltereValues.col_7 = ''
      form.setFieldsValue({ "allSource": "" })
      form.setFieldsValue({ "type_filter": null })
      form.setFieldsValue({ "date_filter": undefined })

      form.setFieldsValue({ "currency": "" })
      form.setFieldsValue({ "getter": "" })
      form.setFieldsValue({ "ammount": "" })
      setFilteredValues(newfiltereValues)
      setDate('')

    }

    if (column === 'amount') {
      newfiltereValues.col_1 = ''
      newfiltereValues.col_2 = ''
      newfiltereValues.col_3 = ''
      newfiltereValues.col_6 = e.target.value?.toLowerCase()
      newfiltereValues.col_5 = ''
      newfiltereValues.col_4 = ''
      newfiltereValues.col_7 = ''
      form.setFieldsValue({ "allSource": "" })
      form.setFieldsValue({ "type_filter": null })
      form.setFieldsValue({ "date_filter": undefined })

      form.setFieldsValue({ "currency": "" })
      form.setFieldsValue({ "appointment": "" })
      form.setFieldsValue({ "getter": "" })
      setFilteredValues(newfiltereValues)
      setDate('')

    }

    if (column === 'currency') {
      newfiltereValues.col_1 = ''
      newfiltereValues.col_7 = e?.toLowerCase()
      newfiltereValues.col_2 = ''
      newfiltereValues.col_3 = ''
      newfiltereValues.col_4 = ''
      newfiltereValues.col_5 = ''
      newfiltereValues.col_6 = ''
      form.setFieldsValue({ "allSource": "" })
      form.setFieldsValue({ "type_filter": null })
      form.setFieldsValue({ "date_filter": undefined })

      form.setFieldsValue({ "getter": "" })
      form.setFieldsValue({ "appointment": "" })
      form.setFieldsValue({ "ammount": "" })
      setDate('')

      setFilteredValues(newfiltereValues)
    }
    if (column === 'user') {
      newfiltereValues.col_8 = e.target.value?.toLowerCase();
      newfiltereValues.col_1 = '';
      newfiltereValues.col_2 = '';
      newfiltereValues.col_3 = '';
      newfiltereValues.col_4 = '';
      newfiltereValues.col_5 = '';
      newfiltereValues.col_6 = '';
      newfiltereValues.col_7 = '';
      form.setFieldsValue({ "allSource": "" });
      form.setFieldsValue({ "type_filter": null });
      form.setFieldsValue({ "date_filter": undefined });
      form.setFieldsValue({ "currency": "" });
      form.setFieldsValue({ "appointment": "" });
      form.setFieldsValue({ "getter": "" });
      form.setFieldsValue({ "ammount": "" });
      setDate('');
      setFilteredValues(newfiltereValues);
    }


    if (tableListForFilter && filtereValues) {
      let filteredData;

      filteredData = tableListForFilter?.filter((sRow: any) =>
        (sRow.allSource ? sRow.allSource?.toLowerCase().includes(filtereValues["col_1"]) : filtereValues["col_1"] === '' ? (sRow.allSource === "" || sRow.allSource === undefined || sRow.allSource === null) : '') &&
        sRow.date.split(' ')[0].toLowerCase().includes(filtereValues["col_2"]) &&
        sRow.type.toLowerCase().includes(filtereValues["col_3"]) &&
        (sRow.getter ? sRow.getter?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_4"]) : filtereValues["col_4"] === '' ? (sRow.getter === "" || sRow.getter === undefined || sRow.getter === null) : "") &&
        (sRow?.assignment ? sRow?.assignment?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_5"]) : filtereValues["col_5"] === '' ? (sRow?.assignment === "" || sRow?.assignment === undefined || sRow?.assignment === null) : "") &&
        (sRow?.amount ? sRow?.amount?.toString().toLowerCase().normalize().replace(/[\u0300-\u036f,(/\s/g,'');]/g, '').includes(filtereValues["col_6"]) : filtereValues["col_6"] === '' ? (sRow?.amount === "" || sRow?.amount === undefined || sRow?.amount === null) : "") &&
        (sRow.currency ? sRow.currency?.toLowerCase().includes(filtereValues["col_7"]) : filtereValues["col_7"] === '' ? (sRow.currency === "" || sRow.currency === undefined || sRow.currency === null) : "") &&
        (sRow.user ? sRow.user?.toLowerCase().includes(filtereValues["col_8"]) : filtereValues["col_8"] === '' ? (sRow.user === "" || sRow.user === undefined || sRow.user === null) : "")
      );

      // console.log(filteredData)
      setTableFilterList(filteredData)
      setTableListForSortOriginal(filteredData)
      setCurrent(1)
      if (filtereValues["col_1"] === 'all') {
        setTableFilterListForFilter(tableListForFilter)
        setTableFilterList(tableListForFilter)

      }

      if (filtereValues["col_2"] === 'all') {
        form.resetFields(['date_filter'])
      }

      if (filtereValues["col_3"] === 'all') {
        setTableFilterList(tableListForFilter)
        setTableListForSortOriginal(tableListForFilter)
        form.resetFields(['type_filter'])
      }

      if (filtereValues["col_7"] === 'all') {
        setTableFilterListForFilter(tableListForFilter)
        setTableFilterList(tableListForFilter)
        form.resetFields(['currency_filter'])
      }

    }

  }

  useEffect(() => {
    simaPollingActive.current = simaModalVisible && !simaExpired
  }, [simaModalVisible, simaExpired])

  useEffect(() => {
    if (!simaModalVisible || simaExpired) return
    setSimaTimeLeft(SIMA_SIGN_DURATION)
    setSimaExpired(false)
    const timer = setInterval(() => {
      setSimaTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer)
          setSimaExpired(true)
          return 0
        }
        return prev - 1
      })
    }, 1000)
    return () => clearInterval(timer)
  }, [simaModalVisible, simaRefreshKey])

  const refreshSimaQr = () => {
    setSimaQrCode('')
    setSimaExpired(false)
    setSimaSignError(false)
    setSimaSignErrorMsg('')
    setSimaRefreshKey(k => k + 1)
    newTransferFunc(requestType).then((res: any) => {
      if (res?.resultMessage === "SUCCESS") {
        setSimaQrCode(res?.data?.qrCode || '')
        checkSimaSigningStatus(res?.data?.verfication)
      } else {
        setSimaSignErrorMsg(res?.message || t("notification.errorOccured"))
        setSimaSignError(true)
      }
    }).catch(() => {
      setSimaSignErrorMsg(t("notification.errorOccured"))
      setSimaSignError(true)
    })
  }

  const checkSimaSigningStatus = (code: string) => {
    simaPollingActive.current = true
    setPopupType("success")
    return new Promise((resolve, reject) => {
      function checkResponse() {
        if (!simaPollingActive.current) return
        httpVeryfied()
          .get(`${API_URL}transaction/status/${code}`)
          .then((response: any) => {
            if (!simaPollingActive.current) return
            let data = response.data.data
            if (data?.lastStatus == 'SIGNATURE_CREATED' && response?.data?.status == 'SUCCESS') {
              if (data?.trnDetails?.length > 0 && data.trnDetails[0].status === "WARN")
                setModalText(t("notification.sentToBank"))
              else if (data?.trnDetails?.length > 0 && data.trnDetails[0].status === "OUTOF")
                setModalText(t("notification.sentToBankAndProcessedNextDay"))
              else if (data?.trnDetails?.[0]?.trnStatus === "BANK_SUCCESS")
                setModalText(t("notification.transferSentToBank"))
              else
                setModalText(t("notification.transferCreatedSigned"))
              setPopupType('success')
              setSimaModalVisible(false)
              setShowSuccessOrError(true)
            } else if (data?.lastStatus == 'OUTSTANDING_TRANSACTION') {
              window.setTimeout(checkResponse, 1000)
            } else {
              setSimaSignErrorMsg(response.data.message || t("notification.errorOccured"))
              setSimaSignError(true)
            }
          }).catch(() => {
            if (!simaPollingActive.current) return
            setSimaSignErrorMsg(t("notification.errorOccured"))
            setSimaSignError(true)
          })
      }
      window.setTimeout(checkResponse, 4000)
    })
  }

  const checkAsanVerifyCodeTransfers = (code: number) => {
    return new Promise((resolve, reject) => {
      function checkResponse() {
        httpVeryfied()
          .get(`${API_URL}transaction/status/${code}`)
          .then((response: any) => {
            let data = response?.data?.data
            if (data?.lastStatus == 'SIGNATURE_CREATED' && response?.data?.status == 'SUCCESS') {
              if (data?.trnDetails[0].status === "WARN")
                setModalText(t("notification.sentToBank"))
              else if (data?.trnDetails[0].status === "OUTOF")
                setModalText(t("notification.sentToBankAndProcessedNextDay"));
              else if (data?.trnDetails[0].trnStatus === "BANK_ERROR") {
                if (data?.trnDetails[0].status === "LIMIT") {
                  setModalText(data?.trnDetails[0].message)
                  setPopupType('error');
                } else {
                  setModalText(t("notification.errorOccuredWhenSendToBank"));
                }
              }
              else if (data?.trnDetails[0].trnStatus !== "BANK_SUCCESS") {
                if (data?.userRole === "SIGNER")
                  setModalText(t("notification.transferSigned"));
                else
                  setModalText(t("notification.transferConfirmed"));
                setPopupType('success');
              }
              // else if (RequestType === "BANK_ERROR") {
              //   setModalText(t("notification.transferSentToBank"));
              //   setPopupType('success');
              // }
              else if (data?.trnDetails[0].trnStatus === "BANK_SUCCESS") {
                setModalText(t("notification.transferSentToBank"));
                setPopupType('success');
              }
              setAsanModalVisible(false)
              setShowSuccessOrError(true)
            } else if (data.lastStatus == 'OUTSTANDING_TRANSACTION') {
              window.setTimeout(checkResponse, 1000)
            } else {
              if (data?.trnDetails[0].trnStatus === "BANK_ERROR")
                if (data?.trnDetails[0].status === "LIMIT") {
                  setModalText(data?.trnDetails[0].message)
                  setPopupType('error');
                } else {
                  setModalText(t("notification.errorOccuredWhenSendToBank"));
                }
              else
                setModalText(response.data.message !== null ? response.data.message : "")
              setAsanModalVisible(false)
              setShowSuccessOrError(true)
              setPopupType("error")
            }
          }).catch((e) => {
            setAsanModalVisible(false)
            setShowSuccessOrError(true)
            setPopupType("error")
            setModalText(t("notification.errorOccured"))
          })
      }
      checkResponse()
    })
  }

  const sendTransactionRequest = (RequestType: string) => {
    setLoadingApprove(true)
    newTransferFunc(RequestType).then((res) => {
      setLoadingApprove(false)
      if (res?.resultMessage === "SUCCESS") {
        if (RequestType === 'APPROVE' || RequestType === 'SEND_BANK') {
          if (RequestType === 'APPROVE') {
            if (res?.fileDescriptors[0]?.trnStatus === "BANK_SUCCESS") {
              if (res?.fileDescriptors[0]?.status === "WARN")
                setModalText(t("notification.sentToBank"))
              else if (res?.fileDescriptors[0]?.status === "OUTOF")
                setModalText(t("notification.sentToBankAndProcessedNextDay"));
              else
                setModalText(t("notification.transferSentToBank"));
            }
            else
              setModalText(t("notification.transferConfirmed"));
            setPopupType('success');
          } else {
            if (res?.fileDescriptors[0]?.status === "WARN")
              setModalText(t("notification.sentToBank"))
            else if (res?.fileDescriptors[0]?.status === "OUTOF")
              setModalText(t("notification.sentToBankAndProcessedNextDay"));
            else
              setModalText(t("notification.transferSentToBank"));
            setPopupType('success');
          }
          setShowSuccessOrError(true)
        }
        else {
          if (channel === 'TOTP' || channel === 'OTP') {
            // let phone_number = localStorage.getItem('phoneNumber');
            let phone_number = secureLocalStorageGet('phoneNumber');
            let last_4_number = phone_number.slice(-4)
            let make_phone_number = last_4_number && last_4_number.length >= 4
              ? last_4_number[0] + last_4_number[1] + '-' + last_4_number.slice(-2)
              : ''

            setOtpNumberCount((old_number) => (channel === 'TOTP' ? 6 : 5))
            setPhoneNumber((old_data) => make_phone_number)
            showOtpCodeModal()
          } else if (channel === 'SIMA') {
            const qrCode = res?.qrCode || ''
            const txCode = res?.verfication
            console.log(txCode);
             console.log("res5",res);
            setSimaQrCode(qrCode)
            setSimaExpired(false)
            setSimaSignError(false)
            setSimaSignErrorMsg('')
            setSimaModalVisible(true)
            checkSimaSigningStatus(txCode)
          } else {
            let verify_code = res?.data?.verfication
            setVerifyCode((old_code) => verify_code)
            checkAsanVerifyCodeTransfers(verify_code)
            setAsanModalVisible(true)
          }
        }
      } else {
        if (res?.resultCode !== "500" && res?.resultCode !== "BrServiceErr") {
          setModalText((res?.detail !== undefined ? res?.detail : '' + ' ') + (res?.message !== undefined ? res?.message : '' + ' ') + (res?.resultMessage !== undefined ? res?.resultMessage : ''));
          setPopupType('error');
          setShowSuccessOrError(true)
        } else {
          setShowSuccessOrError(true)
          // if(props.selectedType === "BANK_ERROR")
          //   setModalText(t("transfers.useSendToBankButtonAgain"))
          // else
          setModalText(t("notification.errorOccuredWhenSendToBank"));
          setPopupType('error');
        }
      }
    }).catch((e) => {
      setLoadingApprove(false)
      setPopupType('error');
      setModalText(e?.data?.detail)
    })
  }

  const newTransferFunc = (value) => {
    let ibankArr = selectedRowKeys.map((item: number) => {
      return {
        ibankref: item,
      };
    });
    let postData = {
      trnRequestType: value,
      fileDescriptors: ibankArr
    }
    return sendTransactionApprove(postData)
  }

  const resetForm = () => {
    setOtpCodeModalVisible(false)
    setShowTimeError(true)
    // inputRef.current.__clearvalues__()
  }

  const formatRemainingTime = (time: number) => {
    const minutes = Math.floor((time % 1200) / 60)
    const seconds = time % 60

    return `0${minutes}:${seconds == 0 || seconds < 10 ? `0${seconds}` : seconds}`
  }

  const renderTime = ({ remainingTime }) => {
    if (remainingTime === 0) {
      return <div className="timer"></div>
    }

    return (
      <div className="timer">
        <div className="value">{formatRemainingTime(remainingTime)}</div>
      </div>
    )
  }

  const handleValue = (value: any) => {
    setOtpCode(value)
  }

  const showOtpCodeModal = () => {
    setOtpCodeModalVisible(true)
    setClicked(false)
    setOtpCode((old_data) => [])
    setOtpCodeHasError((old_data) => false)
  }

  const handleTransactionReq = () => {
    sendTransactionRequest(requestType)
  }

  const reSend = () => {
    setClicked(false)
    handleTransactionReq();
    setReset(true);
    setTimeout(() => setReset(false), 1000);
  }

  const resetFormTimer = () => {
    setOtpCodeModalVisibleTrList(false)
   
  }

  useEffect(() => {
    if (!smsClicked) {
      let timer1 = setInterval(() => setClicked(true), 20 * 1000)
      return () => { clearInterval(timer1) }
    }
  }, [smsClicked])

  const reSendTrList = () => {
    if (smsClicked) {
      setClicked(false)
      getTransfersFiltered(businessDate as any, argument as any, 1, language)
      // setReset(true)
      // setTimeout(() => setReset(false), 1000)
    }
  }

  const checkOTPCode = () => {
    setModalText(t("notification.sendingToBankNotif"))
    setPopupType("success")
    setLoadingSend(true)
    if (otpCode.length == 5 || otpCode.length == 6) {
      getTransactionStatus(otpCode).then((res) => {
        setLoadingSend(false)

        if (res.status === 'ERROR' && res.code === 3) {
          setOtpCodeHasError((old_data) => true)
          // setOtpCodeError(res.message);
        } else if (res.status === 'ERROR' && res.code === 5) {
          setOtpCodeHasError((old_data) => true)

        } else if (res.status === 'ERROR' && res.code === 500) {
          setOtpCodeHasError((old_data) => false)
          setOtpCodeModalVisible(false)
          if (res?.data?.trnDetails[0].status === "LIMIT") {
            setModalText(res?.data?.trnDetails[0].message)
            setPopupType('error');
          } else {
            setModalText(t("notification.errorOccuredWhenSendToBank"));
          }
          setPopupType('error');
          setShowSuccessOrError(true)
          setLoadingSend(false)

        } else {
          if (res?.data?.trnDetails[0].status === "WARN")
            setModalText(t("notification.sentToBank"))
          else if (res?.data?.trnDetails[0].status === "OUTOF")
            setModalText(t("notification.sentToBankAndProcessedNextDay"));
          else if (res?.data?.trnDetails[0].trnStatus === "BANK_ERROR")
            if (res?.data?.trnDetails[0].status === "LIMIT") {
              setModalText(res?.data?.trnDetails[0].message)
              setPopupType('error');
            } else {
              setModalText(t("notification.errorOccuredWhenSendToBank"));
            }
          else if (res?.data?.trnDetails[0].trnStatus !== "BANK_SUCCESS") {
            if (res?.data?.userRole === "SIGNER")
              setModalText(t("notification.transferSigned"));
            else
              setModalText(t("notification.transferConfirmed"));
            setPopupType('success');
          }
          // else if (props.selectedType === "BANK_ERROR") {
          //   setModalText(t("notification.transferSentToBank"));
          //   setPopupType('success');
          // }
          else if (res?.data?.trnDetails[0].trnStatus === "BANK_SUCCESS") {
            setModalText(t("notification.transferSentToBank"));
            setPopupType('success');
          }
          setOtpCodeHasError((old_data) => false)
          // setOtpCodeError('');
          setOtpCodeModalVisible(false)
          setShowSuccessOrError(true)
          setLoadingSend(false)

          // props.onStatusChange(true)
        }
      }).catch((e) => {
        setOtpCodeModalVisible(false)
        setShowSuccessOrError(true)
        setLoadingSend(false)
        setPopupType("error")
        setModalText(t("notification.errorOccured"))
      })
    }

  }

  const onClose = () => {
    handleModalClose()
    setAsanModalVisible(false)
    setOtpCodeModalVisible(false)
    setShowSuccessOrError(false)
  }

  const setButtonClickedTriggerChildFunc = () => {
    setButtonClickedTriggerChild(buttonClickedTriggerChild + 1)
  }
  const handleSelectLanguage = (value: any) => {
    setSelectLanguage(value)
  }
  const onPageChange = (newPagination: number) => {
    setCurrent(newPagination);
  };

  const allRowKeys = (tableList || []).map((item: any) => item.key);

  const rowSelection = {
    selectedRowKeys,
    onChange: (keys: React.Key[]) => {
      // Call your main handler
      onSelectChange(keys);
    },
    columnWidth: 20,
    columnTitle: (
      <Checkbox
        indeterminate={
          selectedRowKeys.length > 0 &&
          selectedRowKeys.length < allRowKeys.length
        }
        checked={
          allRowKeys.length > 0 &&
          selectedRowKeys.length === allRowKeys.length
        }
        disabled={allRowKeys.length === 0}
        onChange={(e) => {
          if (e.target.checked) {
            // Select all
            onSelectChange(allRowKeys);
          } else {
            // Unselect all
            onSelectChange([]);
          }
        }}
      />
    ),
  };


  const handleValueTrList = (value: any) => {
    setOtpCodeTrList(value)
    if (otpCodeHasErrorTrList) {
      setOtpCodeHasErrorTrList(false)
      setErrorText('')
    }
  }
  const hideOtpCodeModal = () => {
   
    setOtpCodeTrList('')
    setErrorText('')
    setOtpCodeHasErrorTrList(false)
    setOtpCodeModalVisibleTrList(false)
  }
  const checkOTPCodeTrList = async () => {
    setLoading(true)
    try {
      
      
      const fetchData = async () => {
      let transfersData: Array<any> = []
      let countData: Array<any> = []
      let filterByStatus: Array<any> = []
      
      // setEndDate(endDateData)
      // setStartDate(startDateData)
 
       
      let packages_array = [{ label: t("common.all"), value: 'all' }];
      let pack_arr: any = [{ label: t("common.all"), value: 'all' }]
      transfersData = await getTransfersFiltered(businessDate, argument, 1, language,otpCodeTrList)
      setOtpCodeModalVisibleTrList(false)
      setOtpCodeHasErrorTrList(false)
      setErrorText('')
      setOtpCodeTrList('')
      setTableListCash([])
      setBtnCount([])
      setTableFilterList([])
      setTableFilterListForFilter([])
      setTableListForSortOriginal([])
      countData = await getTransfersStatusCount(argument, businessDate)
      if (countData[0] !== undefined) {
        setSelectedType(countData[0]['status'])
      }

      transfersData.map((r) => {
        console.log("e", r);

        let check_packages = pack_arr.find(row => row.value == r?.batchName)
        if (!check_packages && r.batchName !== null && r.packageNumber !== null) {


          pack_arr.push({
            label: r.packageNumber + " " + "(" + r?.batchName + ")",
            value: r?.batchName
          })

        }
      })
      setPackages(pack_arr)
      let temp_array: Array<any> = []
      let temp_dates = [{ label: t("common.all"), value: 'all' }];
      let temp_types = [{ label: t("common.all"), value: 'all' }];
      let temp_currency = [{ label: t("common.all"), value: 'all' }];
      let source_Array = [{ label: t("common.all"), value: 'all' }];
      setTableListCash(transfersData);
      transfersData.map((item) => {
        let check_source = source_Array.find(row => row.value == item?.allSource)
        if (!check_source) {
          console.log(item.source)
          source_Array.push({
            label: item.allSource !== 'BT' ? (item.allSource === 'API' ? "API" : item.allSource === 'MOBILE' ? 'MO' : "IO") : 'BT',
            value: item?.allSource
          })

        }
        let filter_date = dateFormatter(item.trnDateTime, "DD.MM.YYYY");

        let check_date = temp_dates.find(row => row.value == filter_date);

        if (!check_date) {
          temp_dates.push({ label: filter_date, value: filter_date })
        }
        let check_packages = packages_array.find(row => row.value == item?.batchName)
        if (!check_packages && item.batchName !== null) {
          packages_array.push({
            label: item?.batchName,
            value: item?.batchName
          })

        }
        let check_type = temp_types.find(row => row.value == item.brTrnType);

        if (!check_type) {
          temp_types.push({ label: typeRenderTransfer(item.brTrnType), value: item.brTrnType })
        }

        let check_currency = temp_currency.find(row => row.value == item.pmtCurr || item.currency);

        if (!check_currency) {
          temp_currency.push({ label: item.pmtCurr || item.currency, value: item.pmtCurr || item.currency })
        }


        return temp_array.push({
          key: item.ibankRef,
          date: item.trnDateTime,
          user: item?.lastUser,
          lastUserName: item.lastUserName,
          type: item.brTrnType,
          getter: item.benefName ? item.benefName : '',
          assignment: item.description,
          currency: item.pmtCurr || item.currency,
          amount: financial(item.amount),
          status: item.status,
          pmtCustId: item.pmtCustId,
          signAvailable: item.signAvailable,
          approveAvailable: item.approveAvailable,
          customerAccount: item.customerAccount,
          actionButtons: item.actionButtons,
          allSource: item.source,
          batchName: item.batchName,
          info: item.infoToBenef
        })
      })
      let cntBtn: Array<any> = []
      if (countData !== undefined) {
        countData.map((item) => {
          const name = statusRender(item.status);
          if (name !== null) {
            cntBtn.push(item)
          }
        })
      }
      setBtnCount(cntBtn)
      let countSign = temp_array.filter(
        (obj) => obj.signAvailable === 'true' || obj.approveAvailable == 'true'
      ).length
      setForSign(countSign)
      if (checked.toString() === 'true') {
        let temp_dates = [{ label: t("common.all"), value: 'all' }];
        let temp_types = [{ label: t("common.all"), value: 'all' }];
        let temp_currency = [{ label: t("common.all"), value: 'all' }];
        let source_Array = [{ label: t("common.all"), value: 'all' }];
        let packages_array = [{ label: t("common.all"), value: 'all' }];

        const filtered = temp_array.filter((row) => {
          if (row['signAvailable'] == 'true' || row['approveAvailable'] == 'true') {
            let filter_date = dateFormatter(row.date, "DD.MM.YYYY");

            let check_date = temp_dates.find(row => row.value == filter_date);

            if (!check_date) {
              temp_dates.push({ label: filter_date, value: filter_date })
            }
            let check_source = source_Array.find(item => item.value == row?.allSource)
            if (!check_source) {
              source_Array.push({
                label: row.allSource !== 'BT' ? (row.allSource === 'API' ? "API" : row.allSource === 'MOBILE' ? 'MO' : "IO") : 'BT',
                value: row?.allSource
              })
            }
            let check_type = temp_types.find(item => item.value == row.type);

            if (!check_type) {
              temp_types.push({ label: typeRenderTransfer(row.type), value: row.type })
            }

            let check_packages = packages_array.find(row => row.value == row?.batchName)
            if (!check_packages && row.batchName !== null) {
              packages_array.push({
                label: row?.batchName,
                value: row?.batchName
              })

            }
            let check_currency = temp_currency.find(item => item.value == row.pmtCurr || row.currency);

            if (!check_currency) {
              temp_currency.push({ label: row.pmtCurr || row.currency, value: row.pmtCurr || row.currency })
            }
          }
          return row['signAvailable'] == 'true' || row['approveAvailable'] == 'true'
        })

        setTableFilterList(filtered)
        setTableFilterListForFilter(filtered)
        setTableListForSortOriginal(filtered)
        setDateList(temp_dates)
        // setPackages(packages_array)

        setTransferData(source_Array)
        setTypeList(temp_types)
        setCurrencyList(buildCurrencyList(filtered));
      }
      else if (cntBtn.length > 0) {
        let index = cntBtn.length == 1 ? 0 : activeIndex
        let temp_dates = [{ label: t("common.all"), value: 'all' }];
        let temp_types = [{ label: t("common.all"), value: 'all' }];
        let temp_currency = [{ label: t("common.all"), value: 'all' }];
        let source_Array = [{ label: t("common.all"), value: 'all' }];
        let packages_array = [{ label: t("common.all"), value: 'all' }];

        filterByStatus = temp_array.filter(
          (obj) => {
            if (obj.status == cntBtn[index].status.toString()) {

              let filter_date = dateFormatter(obj.date, "DD.MM.YYYY");

              let check_date = temp_dates.find(row => row.value == filter_date);

              if (!check_date) {
                temp_dates.push({ label: filter_date, value: filter_date })
              }
              let check_source = source_Array.find(row => row.value == obj?.allSource)

              if (!check_source) {
                source_Array.push({
                  label: obj.allSource !== 'BT' ? (obj.allSource === 'API' ? "API" : obj.allSource === 'MOBILE' ? 'MO' : "IO") : 'BT',
                  value: obj?.allSource
                })

              }
              let check_type = temp_types.find(item => item.value == obj.type);

              if (!check_type) {
                temp_types.push({ label: typeRenderTransfer(obj.type), value: obj.type })
              }
              let check_packages = packages_array.find(row => row.value == obj?.batchName)
              if (!check_packages && obj.batchName !== null) {

                packages_array.push({
                  label: obj?.batchName,
                  value: obj?.batchName
                })

              }
              let check_currency = temp_currency.find(item => item.value == obj.pmtCurr || obj.currency);

              if (!check_currency) {
                temp_currency.push({ label: obj.pmtCurr || obj.currency, value: obj.pmtCurr || obj.currency })
              }
            }
            return obj.status == cntBtn[index].status.toString()
          }
        )

        setTableFilterList(filterByStatus)
        setTableFilterListForFilter(filterByStatus)
        setTableListForSortOriginal(filterByStatus)

        // setPackages(packages_array)
        setDateList(temp_dates)
        setTypeList(temp_types)
        setTransferData(source_Array)
        setCurrencyList(buildCurrencyList(filterByStatus));
      }
      else {
        setTableFilterList(temp_array)
        setTableFilterListForFilter(temp_array)
        setTableListForSortOriginal(temp_array)

        // setPackages(packages_array)
        setDateList(temp_dates)
        setTypeList(temp_types)
        setTransferData(source_Array)

        setCurrencyList(buildCurrencyList(temp_array));
      }
      setTableLoading({
        ...tableLoading,
        spinning: false
      });
      setLoading(false)
    }
    const buildCurrencyList = (rows: any[]) => {
      const list = [{ label: t("common.all"), value: "all" }];

      rows.forEach((row) => {
        const curr = row.currency || row.pmtCurr;
        if (!curr) return;

        const exists = list.find(item => item.value === curr);
        if (!exists) {
          list.push({ label: curr, value: curr });
        }
      });

      return list;
    };
    await fetchData()
    

    } catch (error) {
      console.log(error)
      if (error !== null) {
        setOtpCodeHasErrorTrList(true);
        setErrorText(error?.data?.detail)
        setLoading(false)

      } else {
        console.error("Başqa bir sistem xətası.");
      }
    }

  }

  // @ts-ignore
  return (
    <>
      {
        tableLoading.spinning ? <FullScreenLoading /> : <></>
      }
      <div
        className="transfer__title"
        style={{ justifyContent: 'space-between' }}
      >
        <p>
          <div onClick={() => history.push('/')}>
            <NavigationLeftIco />
          </div>
          {t("home.transfers")}{' '}
          <span style={{ marginRight: 12, marginLeft: 10 }} className='internetOffice'>
            {' '}
            “İnternet Ofis”də{' '}
          </span>
          <CustomTooltip
            overlayClassName={'tooltip'}
            // placement="rightTop"
            title={messageList?.result !== undefined ? (language == "az" ? messageList.result.find(text => text.messageKey === 'INFO.ALL_TRANSACTION')?.textAZE : language == "ru" ? messageList.result.find(text => text.messageKey === 'INFO.ALL_TRANSACTION')?.textRU : language == "en" ? messageList.result.find(text => text.messageKey === 'INFO.ALL_TRANSACTION')?.textENG : "") : ""}
            style={{ maxHeight: '60px' }}
          >
            <TabsInfoIco className='internetOfficeInfo' />
          </CustomTooltip>
        </p>
        <div className="flex">
          <span style={{ margin: 'auto 8px' }}>
            <Button
              icon={<CycleIco />}
              type="ghost"
              onClick={handleRefresh}
            />
          </span>
          {dateFormatter(new Date())}
        </div>
      </div>
      <Col
        span={24}
        style={{ backgroundColor: '#fff', borderRadius: 10 }}
        className="transfers transfer-mobile-scroll"
        ref={ref}
      >
        <div style={{ minWidth: "1300px" }}>
          <TransfersFilter
            selectAccountOptions={selectAccountOptions}
            selectStatusOptions={selectStatusOptionsStatic}
            handleStatusFilter={filterHandler}
            businessDate={businessDate}
            handleDateData={handleDateData}
            handleDateFilter={() => setDateIndex(0)}
            formValue={formValue}
            packages={packages}
            activeDateIndex={activeIndexDate}
            handleFilter={(args: any) => {
              handleTransfersFilter(args, activeIndex);
              setArgCash(args)
            }
            }
            startDate={startDate}
            endDate={endDate}
            buttonClickedTriggerChild={buttonClickedTriggerChild}
          // handleDateFilter={(key: string, fromDate: Date, toDate: Date) =>
          //   handleDateFilter(
          //     key,
          //     moment(fromDate).format('DD-MM-YYYY'),
          //     moment(toDate).format('DD-MM-YYYY')
          //   )
          // }
          // tableData={tableData}
          />
          <Col className="salary-transfer__table__divider">
            <div className="salary-transfer__table transfers-table d-flex">
              <Row style={{ justifyContent: 'start' }}>
                <ul className="d-flex">
                  {(roleData === 2 || roleData === 3) &&
                    <li className={'transfer_li_border d-flex'}>
                      <div className={'d-flex transfer_button_div'}>
                        <CircleCheckbox
                          checked={checked}
                          onCheckboxChange={handleCheckboxClickData}
                        />
                        <p onClick={handleCheckboxClickData}>{roleRender(roleData.toString())}</p>
                        <span className="statistics-count-button">{statusForSign}</span>
                      </div>
                    </li>
                  }
                </ul>
              </Row>
              <Row style={{ justifyContent: 'space-between', width: '100%', marginLeft: '30px' }}>
                <ul className="d-flex transfers__statistics transfer_ul">
                  {btnCount.map((item, index) => {
                    return (
                      <li
                        onClick={() => handleStatTabClick(item, index)}
                        className={
                          activeIndex === index && !checked ? 'active' : ''
                        }
                      >
                        <p>{statusRender(item.status)}</p>
                        <span className="statistics-count">{item.count}</span>
                      </li>
                    )
                  })}
                </ul>
                <div className="flex pagination-selector-transfer">
                  <p>{t("salary.numberAtPage")} </p>
                  <Select
                    // open={true}
                    defaultValue={10}
                    dropdownClassName={'hoverable pagination-select'}
                    onChange={(value) => setPageSize(value)}
                  >
                    {pageOptions.map((item) => {
                      return <option value={item}>{item}</option>
                    })}
                  </Select>
                </div>
              </Row>
            </div>
           <TableComponent
              className="transfer-table salary-table transfers-table__component home_account_opt_table transfer-table-only transfer_main_table"
              columns={columnsData}
              rowKey="key"
              data={tableList}
              rowSelection={rowSelection}
              onRow={(record: any) => ({
                onClick: () => handleRowClick(record.key, record.type),
              })}
              scroll={{ x: '100%' }}
              pagination={true}
              current={current}
              pageSize={pageSize}
              onPageChange={onPageChange}
              position="bottom center"
              alignment="center"
              onClose={() => setModalVisibility(false)}
            />
            {tableList?.length == 0 && <div className={'noDataTransfer'}>
              <div className={'noDataTransferDiv'}>{t("transfers.informationNotAvailable")}</div>
            </div>}
          </Col>
          {tableList.length > 0 && (
            <TransfersFooter
              fileDescriptors={selectedRowKeys}
              data={selectedRowKeys.length == 1 || row ? innerTableData : []}
              type={selectedRowKeys.length == 1 || row ? type : 'common'}
              type1={type1}
              disabledSign={!checked || selectedRowKeys.length == 0}
              disabledSignModal={!checked}
              modalData={
                selectedRowKeys.length == 1 || row ? modalDataSingle : ''
              }
              modalDataCommon={
                selectedRowKeys.length > 1 ? commonModalData : ''
              }
              onCloseSign={handleModalClose}
              handleRepeat={handleRepeat}
              modalType={modalType}
              handleDelete={handleDelete}
              //@ts-ignore
              salaryData={detailDataState}
              tableData={detailDataState}
              documentDetail={documentDetail}
              visibleDetail={modalVisible}
              handleSignClick={() => handleSign()}
              handleGetFileClick={(value: any) => handleGetPdfSingle(value)}
              handleGetFileClickMultiple={() => handleGetPdfMultiple()}
              handleGetAdocFileClick={() => handleGetAdoc()}
              handleGetSimaAdocFileClick={() => handleGetSimaAdoc()}
              handleOtherClick={() => handleOther()}
              handleDownloadCheck={() => handleDownloadCheck()}
              disabledEdit={btnData !== {} && selectedRowKeys.length === 1 ? !btnData['editButton'] : true}
              disabledDelete={btnData !== {} ? !btnData['deleteButton'] : true}
              disabledRepeat={btnData !== {} && selectedRowKeys.length === 1 ? !btnData['repeatButton'] : true}
              disabledXLS={btnData !== {} ? !btnData['excelButton'] : true}
              disabledPDF={btnData !== {} ? !btnData['singlePdfButton'] : true}
              disabledADOC={btnData !== {} ? !btnData['adocButton'] : true}
              disabledSimaAdoc={simaAdocDisable}
              simaAdocModalVisible={simaAdocModalVisible}
              disabledSwift={btnData !== {} ? !btnData['swiftButton'] : true}
              disabledReceipt={btnData !== {} ? !btnData['receiptButton'] : true}
              btnData={btnDataModal}
              disabledSWIFT={true}
              selectedRow={selectedRowKeys.length}
              loadingPdf={loadingPdf}
              loadingAll={loadingAll}
              selectedType={selectedType}
              multiple={multiple}
              currentForm={form}
              reLoadData={reLoadData}
              handleEdit={handleEdit}
              openedIbanRef={selectedIbanRef}
              innerrtableData={noteList}
              historyList={historyList}
              handleGetAllExcel={handleGetAllExcel}
              handleGetPdfAdditional={handleGetPdfAdditional}
              handleGetExcelAdditional={handleGetExcelAdditional}
              loadingExcel={loadingExcel}
              setButtonClickedTriggerChildFunc={setButtonClickedTriggerChildFunc}
              loadingApprove={loadingApprove}
              handleSelectLanguage={handleSelectLanguage}
            />
          )}
        </div>
      </Col>
      <NextModalTransfers

        callBackApi={handleDeleteCallBackApi}
        visibleDeleteModal={visibleDeleteModal}
        onClose={(isOk: any) => {
          console.log(chainModalConnect)

          if (chainModalConnect && isOk) {
            setChainModal(true)
          } else if (isOk) {
            reLoadData()
            setVisibleDeleteModal(false)
            // setModalVisibility(false)
          } else if (!isOk) {
            setVisibleDeleteModal(false)
            // setModalVisibility(false)
          }

        }}
        onCloseSuccessModal={() => {
          console.log(chainModalConnect)
          if (chainModalConnect) {
            setChainModal(true)
          } else {
            reLoadData()
            setVisibleDeleteModal(false)
            setModalVisibility(false)
          }
        }}
        className={'transfer_own_account'}
        nextModalTitle={t("home.transfer")}
        nextModalText={`Əməliyyat uğurla saxlanılmış, imzalanmışdır və banka göndərilməsini gözləməkdədir.`}
        currentForm={form}

      />

      <SuccessOrErrorModal
        visible={chainModal}
        modalType={"info"}
        className='succesModaltransferdelete'
        modalTitle={t("common.attention")}
        modalText={t("common.infoTransfer")}
        onCancel={() => {
          reLoadData()
          setVisibleDeleteModal(false)
          setModalVisibility(false)
        }}
        modalFooter={<Button onClick={() => {
          reLoadData()
          setVisibleDeleteModal(false)
          setModalVisibility(false)
          setChainModal(false)
        }} className='blue-button' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '13px 20px', height: '40px' }}>{t("common.close")}</Button>}
      // delete={true}
      />

      {asanModalVisible && (
        <Modal
          title={`ASAN IMZA`}
          // closeIcon={<ModalCloseIco />}
          closable={false}
          centered
          visible={asanModalVisible}
          // onOk={onClose}
          // onCancel={onClose}
          width={422}
          className={`manage_faster_menus swift_modal form_next_modal `}
          keyboard={false}
          focusTriggerAfterClose={false}
          footer={false}
        >
          <div className={'flex direction_column asan_sign_popup'}>
            <ul className="office-card__list">
              <li>
                <img src={asanLogo} alt="asan-logo" />
              </li>
              <li>
                <Tooltip
                  id="verificationTooltip"
                  title={text}
                  placement="topRight"
                >
                  <img src={questionMark} alt="question-mark" />
                </Tooltip>
              </li>
            </ul>

            <p>{t(LOGIN_PAGE.MESSAGE)}</p>
            <div className="office-card__statistics mt-15 mb-15">
              {t("modal.controlCode")}
              <span>{verifyCode}</span>
            </div>
            <div className="countdown">
              <CountdownCircleTimer
                isPlaying
                duration={120}
                size={80}
                strokeWidth={3}
                colors={[['#015cd1']]}
                onComplete={resetForm}
              >
                {renderTime}
              </CountdownCircleTimer>
            </div>
          </div>
        </Modal>
      )}

          {simaModalVisible && !simaSignError && (
  <Modal
    title="SİMA ilə imzalama"
    closable={false}
    centered
    visible={simaModalVisible}
    width={460}
    className="manage_faster_menus swift_modal"
    bodyStyle={{
      padding: '16px 24px 20px',
      height: 600,
      overflowY: 'auto'
    }}
    keyboard={false}
    focusTriggerAfterClose={false}
    footer={false}
  >
    <div
      className="sima-card"
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
      }}
    >
      {simaExpired ? (
        <div className="sima-card__qr sima-card__qr--activate">
          <QRCodeSVG
            className="sima-card__qr-placeholder"
            value={simaQrCode || SIMA_QR_PLACEHOLDER}
            size={200}
            level="H"
            includeMargin={true}
          />

          <Button
            className="sima-card__activate-btn"
            onClick={refreshSimaQr}
            style={{
              width: "40%"
            }}
          >
            QR aktivləşdir
          </Button>
        </div>
      ) : simaQrCode ? (
        <div className="sima-card__qr">
          <QRCodeSVG
            value={simaQrCode}
            size={260}
            level="L"
            includeMargin={true}
          />
        </div>
      ) : (
        <div className="sima-card__qr sima-card__qr--loader">
          <Spin size="large" />
        </div>
      )}

      {simaExpired && (
        <p className="sima-card__expired-label">
          QR müddəti bitmişdir
        </p>
      )}

      <p className="sima-card__expire-label">
        Bitmə vaxtı
      </p>

      <div className="sima-card__timer-wrap">
        <span
          className={`sima-card__timer-badge${
            simaExpired
              ? ' sima-card__timer-badge--expired'
              : ''
          }`}
        >
          {formatSimaTime(
            simaExpired ? 0 : simaTimeLeft
          )}
        </span>
      </div>

      <ol
        className="sima-card__steps"
        style={{
          width: 'fit-content',
          margin: '12px auto 0',
          paddingLeft: 0
        }}
      >
        <li>
          <span>1</span>
          “SİMA İmza” mobil tətbiqini açın.
        </li>

        <li>
          <span>2</span>
          “QR” düyməsini sıxın.
        </li>

        <li>
          <span>3</span>
          QR kodu skan edərək daxil olun.
        </li>
      </ol>

      <p
        style={{
          width: 325,
          textAlign: 'center',
          fontSize: 14,
          fontWeight: 400,
          color: '#223142',
          margin: '15.5px auto 0',
          lineHeight: 'normal'
        }}
      >
        QR kodu oxudan zaman xəta baş verərsə, 157 Çağrı Mərkəzi ilə əlaqə saxlamağınız xahiş olunur.
      </p>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: 20
        }}
      >
        <Button
          size="large"
          style={{
            width: 141,
            height: 48,
            padding: '13px 20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: 10,
            border: '1px solid #015CD1',
            background: '#fff',
            color: '#015CD1',
            fontWeight: 500
          }}
          onClick={() => {
            setSimaModalVisible(false);
            setLoadingApprove(false);
          }}
        >
          {t("sima.back")}
        </Button>
      </div>
    </div>
  </Modal>
)}  

  {simaModalVisible && simaSignError && (
  <Modal
    title={t("common.attention")}
    closeIcon={<span className="sima-error__close">×</span>}
    centered
    visible={simaModalVisible && simaSignError}
    width={580}
    className="manage_faster_menus swift_modal sima_error_modal"
    keyboard={false}
    focusTriggerAfterClose={false}
    footer={false}
    onCancel={() => {
      setSimaModalVisible(false);
      setLoadingApprove(false);
    }}
  >
    <div className="sima-error">
      <div className="sima-error__content">
        <div className="sima-limit__icon">
              <span><EroorIco/></span>
        </div>

        <div className="sima-error__message">
          <p className="sima-error__title">
            Xəta baş verdi!
          </p>

          <p className="sima-error__text">
  {simaSignErrorMsg
    ? simaSignErrorMsg.replace(', ona görə', ', ona görə\n')
    : 'Zəhmət olmasa, yenidən cəhd edin.'}
</p>
        </div>
      </div>

      <div className="sima-error__footer">
        <Button
          type="primary"
          onClick={() => {
            setSimaModalVisible(false);
            setLoadingApprove(false);
          }}
        >
          {t("common.close")}
        </Button>
      </div>
    </div>
  </Modal>
)}

      {otpCodeModalVisible && (
        <Modal
          title={channel == 'OTP' ? t("transfers.signingBySMSCode") : t("transfers.signWithGoogleCode")}
          closeIcon={<ModalCloseIco />}
          centered
          visible={otpCodeModalVisible}
          onOk={() => { setOtpCodeModalVisible(false) }}
          onCancel={() => { setOtpCodeModalVisible(false) }}
          width={422}
          className={`manage_faster_menus swift_modal form_next_modal otp_code_verify_modal`}
          keyboard={false}
          focusTriggerAfterClose={false}
          footer={false}
          maskClosable={false}
        >
          <div
            className={
              'flex direction_column align_center otp_code_verify_modal_body'
            }
          >
            {channel == 'OTP' ?
              <p>
                {t("settings.otpcode1")}{phoneNumber} {t("settings.otpcode2")} <br />
                {t("settings.otpcode3")}
              </p>
              : <p>{t("settings.generatedCode")}</p>
            }

            <Form
              form={form}
              onSubmit={(e: any) => e.preventDefault()}
              onFinish={checkOTPCode}
              shouldAutoFocus={true}
              autoComplete="off"
              className={
                otpCodeHasError
                  ? 'message-input-form flex direction_column justify_center has_error'
                  : 'flex direction_column justify_center message-input-form'
              }
            >
              <OtpInput
                value={otpCode}
                onChange={handleValue}
                numInputs={otpNumberCount}
                inputStyle="otpInput"
                isInputNum={true}
                shouldAutoFocus={true}
                className="message-input-form__input"
              />

              {otpCodeHasError && (
                <>
                  <span className={'verify_code_error flex full justify_center'}>
                    {t("transfers.wrongCodeEntered")}
                  </span>
                  {/*<span className={'verify_code_error flex full justify_center'}>*/}
                  {/*  { otpCodeError }*/}
                  {/*</span>*/}
                </>
              )}

              <div className={'full flex direction_column'}>
                <ul
                  className="message-form__details full"
                  style={{ marginTop: otpCodeHasError ? 16 : 21 }}
                >
                  <li className="message-form__time">
                    {otpCode ? (
                      <Timer timerEnd={resetForm} reset={reset} />
                    ) : (
                      <span>00:00</span>
                    )}
                  </li>
                  {channel == 'OTP' &&
                    <li>
                      <a onClick={reSend} className={(smsClicked) ? 'active' : 'disabled'}>{t("transfers.detailsData")}</a>
                    </li>
                  }
                </ul>

                {/*<Button*/}
                {/*  type={'ghost'}*/}
                {/*  className={'transparent resend_verify_code_btn'}*/}
                {/*  onClick={reSend}*/}
                {/*>*/}
                {/*  SMS kodu yenidən göndər*/}
                {/*</Button>*/}

                <div className="login-form__buttons flex justify_center">
                  <Button
                    size={'large'}
                    className="prev ant-btn ant-btn-lg light-button refresh_btn btn flex align_center justify_center"
                    onClick={() => setOtpCodeModalVisible(false)}
                  >
                    {t("transfers.back")}
                  </Button>
                  <Button
                    size={'large'}
                    className="next ant-btn ant-btn-lg blue-button next_btn btn flex align_center justify_center"
                    htmlType="submit"
                    loading={loadingSend}
                  >
                    {t("login.confirm")}
                  </Button>
                </div>
              </div>
            </Form>
          </div>
        </Modal>
      )}
    
      {otpCodeModalVisibleTrList && (
        <Modal
          title={
            t('transfers.signingBySMSCode')
          }
          closeIcon={<ModalCloseIco />}
          centered
          visible={otpCodeModalVisibleTrList}
          onOk={hideOtpCodeModal}
          onCancel={hideOtpCodeModal}
          width={422}
          className={`manage_faster_menus swift_modal form_next_modal otp_code_verify_modal`}
          keyboard={false}
          focusTriggerAfterClose={false}
          footer={false}
          maskClosable={false}
        >
          <div
            className={
              'flex direction_column align_center otp_code_verify_modal_body'
            }
          >
         
            <p>
              {t('settings.otpcode1')}
              {phoneNumber} {t('settings.otpcode2')} <br />
              {t('settings.otpcode3')}
            </p>
            <Form
              form={form}
              onSubmit={(e: any) => e.preventDefault()}
              onFinish={checkOTPCodeTrList}
              shouldAutoFocus={true}
              autoComplete="off"
              className={
                otpCodeHasErrorTrList
                  ? 'message-input-form flex direction_column justify_center has_error'
                  : 'flex direction_column justify_center message-input-form'
              }
            >
              <OtpInput
                value={otpCodeTrList}
                onChange={handleValueTrList}
                numInputs={otpNumberCountTrList}
                inputStyle="otpInput"
                isInputNum={true}
                shouldAutoFocus={true}
                className="message-input-form__input"
              />

              {otpCodeHasErrorTrList && (
                <span className={'verify_code_error flex full justify_center'}>
                  {errorText}
                </span>
              )}

              <div className={'full flex direction_column'}>
                <ul
                  className="message-form__details full"
                  style={{ marginTop: otpCodeHasError ? 16 : 21 }}
                >
                  <li className="message-form__time">
                    <Timer timerEnd={resetFormTimer} reset={reset} />
                  </li>
                  <li>
                    
                      <a
                        onClick={reSendTrList}
                        className={smsClicked ? 'active' : 'disabled'}
                      >
                        {t('modal.detailsData')}
                      </a>
                    
                  </li>
                </ul>

                {/*<Button*/}
                {/*  type={'ghost'}*/}
                {/*  className={'transparent resend_verify_code_btn' + smsClicked ? 'active' : 'disabled'}*/}
                {/*  onClick={reSend}*/}
                {/*>*/}
                {/*  SMS kodu yenidən göndər*/}
                {/*</Button>*/}

                <div className="login-form__buttons flex justify_center">
                  <Button
                    size={'large'}
                    className="prev ant-btn ant-btn-lg light-button refresh_btn btn flex align_center justify_center"
                    onClick={hideOtpCodeModal}
                  >
                    {t('transfers.back')}
                  </Button>
                  <Button
                    size={'large'}
                    className="next ant-btn ant-btn-lg blue-button next_btn btn flex align_center justify_center"
                    htmlType="submit"
                    loading={loading}
                  >
                    {t('login.confirm')}
                  </Button>
                </div>
              </div>
            </Form>
          </div>
        </Modal>
      )}
      {showSuccessOrError && (
        <SuccessOrErrorModal
          visible={showSuccessOrError}
          modalType={popupType}
          modalTitle={popupType === 'success' ? t("home.transfer") : t("notification.attention")}
          modalText={modalText}
          onClose={() => { onClose(); reLoadData(); }}
        />
      )}

      {showTimeError && (
        <SuccessOrErrorModal
          visible={showTimeError}
          modalType={'error'}
          modalTitle={t("notification.attention")}
          modalText={t("notification.errorOccured")}
          onClose={() => { setShowTimeError(false); }}
          onCancel={() => { setShowTimeError(false); }}
        />
      )}

    </>
  )
}

const mapStateToProps = (state: any) => ({
  formValue: state.transfers.formValue,
  sourceComingPage: (state.transfers && state.transfers.sourceComingPage) ? state.transfers.sourceComingPage : {},
  messageList: state.home.messageList
})

const mapDispatchToProps = {
  getTRanferByIban, setTableData,
  getMessageList
}

export default connect(mapStateToProps, mapDispatchToProps)(Transfers)
